var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1111.89,
    height: 145.49,
    viewBox: "0 0 1111.89 145.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 560 524"
  }, /*#__PURE__*/React.createElement("image", {
    width: 560,
    height: 524,
    xlinkHref: "data:image/png;base64,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"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colorwhistle-website-design-development",
    transform: "translate(-177.415 -632.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6720",
    "data-name": "Path 6720",
    d: "M657.291-2321.593l7.729-9.91,6.832,9.91",
    transform: "translate(616.629 2976.337)",
    fill: "none",
    stroke: "#701FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logo-background-opactity",
    width: 17,
    height: 16,
    transform: "translate(430 690)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("image", {
    id: "logo-background-opactity-2",
    "data-name": "logo-background-opactity",
    width: 31,
    height: 29,
    transform: "translate(729 682)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(177.415 665.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957",
    transform: "translate(66.073 76.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6338",
    "data-name": "Path 6338",
    d: "M898.865,399.987s2.3,8.1,2.3,11.953c0,0,18.508-.289,25.735,0,0,0-.475-7.921-.731-12.763C926.169,399.178,905.764,400.276,898.865,399.987Z",
    transform: "translate(-895.654 -399.178)",
    fill: "#edf1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6339",
    "data-name": "Path 6339",
    d: "M897.118,400.427s-1.121.218-3.211.492c0,0,1.89,9.126,1.67,11.247l3.841.215S899.336,405.078,897.118,400.427Z",
    transform: "translate(-893.907 -399.618)",
    fill: "#f5f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6340",
    "data-name": "Path 6340",
    d: "M938.346,409.62s-2.035.288-6.045.5a46.3,46.3,0,0,0,6.081.212Z",
    transform: "translate(-907.433 -402.857)",
    fill: "#dfe5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6341",
    "data-name": "Path 6341",
    d: "M934.88,402.781a43.611,43.611,0,0,1-11.288,2.042s6.292.144,11.529,0Z",
    transform: "translate(-904.365 -400.447)",
    fill: "#dfe5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M902,413.01s6.461-.184,8.515-.546l-8.664-.714Z",
    transform: "translate(-896.705 -403.607)",
    fill: "#dfe5ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6343",
    "data-name": "Path 6343",
    d: "M894.919,404.961a7.936,7.936,0,0,0,2.868,1.261l-2.707-.1Z",
    transform: "translate(-894.264 -401.215)",
    fill: "#edf1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M897.808,415.339l2.9.843-.092-1A7.211,7.211,0,0,1,897.808,415.339Z",
    transform: "translate(-895.281 -404.817)",
    fill: "#edf1f4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M872.731,414.188,875,410.456l-2.229-1.634a11.019,11.019,0,0,0,.585-3.786l2.619-.883-1.033-4.239-2.732.42a11.016,11.016,0,0,0-2.261-3.091l1.227-2.477-3.731-2.268-1.634,2.228a11.05,11.05,0,0,0-3.786-.584l-.883-2.619-4.239,1.033.42,2.732a11,11,0,0,0-3.092,2.261l-2.477-1.227-2.269,3.732,2.229,1.634a11.063,11.063,0,0,0-.585,3.785l-2.619.883,1.033,4.239,2.732-.421a11.035,11.035,0,0,0,2.26,3.092l-1.227,2.477,3.731,2.269,1.634-2.228a11.02,11.02,0,0,0,3.786.584l.883,2.619,4.239-1.033-.421-2.731a11.045,11.045,0,0,0,3.092-2.261Zm-14.583-2.2a7.881,7.881,0,1,1,10.828-2.639A7.881,7.881,0,0,1,858.148,411.989Z",
    transform: "translate(-811.842 -319.957)",
    fill: "#edf1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M947.415,368.275l1.632-2.683-1.6-1.175a7.9,7.9,0,0,0,.42-2.722l1.884-.635L949,358.011l-1.964.3a7.916,7.916,0,0,0-1.626-2.224l.882-1.781-2.683-1.632-1.176,1.6a7.953,7.953,0,0,0-2.722-.42l-.635-1.883-3.048.743.3,1.964a7.905,7.905,0,0,0-2.223,1.626l-1.781-.882-1.632,2.683,1.6,1.176a7.939,7.939,0,0,0-.42,2.722l-1.883.635.742,3.048,1.964-.3a7.931,7.931,0,0,0,1.626,2.224l-.882,1.781,2.683,1.632,1.175-1.6a7.922,7.922,0,0,0,2.722.42l.635,1.883,3.048-.742-.3-1.964a7.941,7.941,0,0,0,2.224-1.626Zm-10.486-1.582a5.667,5.667,0,1,1,7.786-1.9A5.667,5.667,0,0,1,936.93,366.693Z",
    transform: "translate(-840.549 -306.025)",
    fill: "#edf1f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(60.917 88.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M887.3,420.62h40.368l1.354-2.329H885.947Z",
    transform: "translate(-885.947 -418.291)",
    fill: "#5d3e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M948.79,442.272H950l-2.192-20.385h-2.564Z",
    transform: "translate(-906.837 -419.558)",
    fill: "#5d3e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M945.794,425.41l2.668,2.669-.654-6.191h-2.564Z",
    transform: "translate(-906.837 -419.558)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6400",
    "data-name": "Path 6400",
    d: "M939.155,442.272h1.211l-2.193-20.385h-2.564Z",
    transform: "translate(-903.442 -419.558)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6401",
    "data-name": "Path 6401",
    d: "M887.774,442.272h-1.21l2.192-20.385h2.564Z",
    transform: "translate(-886.164 -419.558)",
    fill: "#5d3e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6402",
    "data-name": "Path 6402",
    d: "M891.84,424.706l-2.551,1.229.427-4.047h2.564Z",
    transform: "translate(-887.124 -419.558)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6403",
    "data-name": "Path 6403",
    d: "M896.72,442.272h-1.21l2.193-20.385h2.564Z",
    transform: "translate(-889.316 -419.558)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6404",
    "data-name": "Path 6404",
    d: "M936.092,424.983l2.616,1.972-.536-5.068h-2.564Z",
    transform: "translate(-903.442 -419.558)",
    fill: "#3d2531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6405",
    "data-name": "Path 6405",
    d: "M900.893,424.027l-2.657,1.907.427-4.047h2.564Z",
    transform: "translate(-890.276 -419.558)",
    fill: "#3d2531"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(50.264 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(12.575)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 6.511,
    cy: 6.511,
    r: 6.511,
    transform: "translate(13.127 48.495)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    "data-name": "Path 6422",
    d: "M925.393,310.774a19.635,19.635,0,1,0-34.93-2.451h0l.005.011c.139.329.29.652.446.971l11.65,25.348,5.864.409v.009l.062,0,.062,0v-.009l5.864-.409Z",
    transform: "translate(-888.915 -281.032)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M924.895,311.841a13.242,13.242,0,1,0-16.289-20.882c-5.766,4.5-.307,7.759,4.191,13.525S919.128,316.339,924.895,311.841Z",
    transform: "translate(-894.975 -283.542)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M888.915,311.352a19.578,19.578,0,0,0,1.548,7.653h0l.005.011c.139.329.29.652.446.971l11.65,25.348,5.864.409v.009l.062,0,.062,0v-.009l8.8-6.8S901.667,337.766,888.915,311.352Z",
    transform: "translate(-888.915 -291.713)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M915.857,336.482h-.648c0-.062.006-6.2.55-12.432a62.52,62.52,0,0,1,1.226-8.568,11.945,11.945,0,0,1-1.363-.777,15.956,15.956,0,0,1-2.33-1.887,15.952,15.952,0,0,1-2.329,1.887,12.086,12.086,0,0,1-1.363.777,62.721,62.721,0,0,1,1.226,8.568c.543,6.236.55,12.371.55,12.432h-.648c0-4.686-.363-14.694-1.735-20.732a5.787,5.787,0,0,1-3.668.362,3.774,3.774,0,0,1-2.875-2.64,2.792,2.792,0,0,1,.781-2.725,3.353,3.353,0,0,1,3.535-.477c1.082.361,1.97,1.87,2.674,4.57a11.643,11.643,0,0,0,1.167-.676,15.223,15.223,0,0,0,2.231-1.8,10.15,10.15,0,0,1-2.849-4.664,2.931,2.931,0,0,1,.524-2.426,4.666,4.666,0,0,1,5.563,0,2.939,2.939,0,0,1,.52,2.427,10.147,10.147,0,0,1-2.849,4.664,15.225,15.225,0,0,0,2.231,1.8,11.616,11.616,0,0,0,1.167.676c.7-2.7,1.592-4.209,2.674-4.57a3.355,3.355,0,0,1,3.535.477,2.791,2.791,0,0,1,.78,2.724,3.776,3.776,0,0,1-2.875,2.641,5.781,5.781,0,0,1-3.667-.362C916.219,321.788,915.857,331.8,915.857,336.482Zm-10.6-25.829a2.285,2.285,0,0,0-1.592.571,2.145,2.145,0,0,0-.59,2.095,3.151,3.151,0,0,0,2.416,2.169,5.219,5.219,0,0,0,3.345-.373c-.58-2.3-1.325-3.912-2.279-4.23A4.106,4.106,0,0,0,905.262,310.653Zm12.481,4.461a5.222,5.222,0,0,0,3.345.373,3.15,3.15,0,0,0,2.416-2.169,2.146,2.146,0,0,0-.59-2.1,2.814,2.814,0,0,0-2.891-.339C919.069,311.2,918.323,312.811,917.743,315.114ZM913.242,305a3.018,3.018,0,0,0-2.24.7,2.33,2.33,0,0,0-.371,1.91,9.723,9.723,0,0,0,2.661,4.3,9.713,9.713,0,0,0,2.661-4.3,2.337,2.337,0,0,0-.368-1.911,3.059,3.059,0,0,0-2.294-.7Z",
    transform: "translate(-893.654 -289.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M922.848,354.575H904.086a1.221,1.221,0,0,1-1.222-1.222h0a1.222,1.222,0,0,1,1.222-1.222h18.762a1.222,1.222,0,0,1,1.222,1.222h0A1.221,1.221,0,0,1,922.848,354.575Z",
    transform: "translate(-893.829 -306.08)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M922.848,358.348H904.086a1.222,1.222,0,0,1-1.222-1.222h0a1.222,1.222,0,0,1,1.222-1.222h18.762a1.222,1.222,0,0,1,1.222,1.222h0A1.222,1.222,0,0,1,922.848,358.348Z",
    transform: "translate(-893.829 -307.409)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M922.848,362.12H904.086a1.222,1.222,0,0,1-1.222-1.222h0a1.222,1.222,0,0,1,1.222-1.222h18.762a1.222,1.222,0,0,1,1.222,1.222h0A1.222,1.222,0,0,1,922.848,362.12Z",
    transform: "translate(-893.829 -308.737)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M922.848,365.893H904.086a1.222,1.222,0,0,1-1.222-1.222h0a1.221,1.221,0,0,1,1.222-1.222h18.762a1.222,1.222,0,0,1,1.222,1.222h0A1.222,1.222,0,0,1,922.848,365.893Z",
    transform: "translate(-893.829 -310.067)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(0 5.454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 7.929,
    height: 0.648,
    transform: "translate(2.486 0) rotate(21.925)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 0.648,
    height: 7.929,
    transform: "matrix(0.373, 0.928, -0.928, 0.373, 9.611, 21.945)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 7.232,
    height: 0.648,
    transform: "translate(0 12.417)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(54.548 5.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 0.648,
    height: 7.929,
    transform: "matrix(0.373, 0.928, -0.928, 0.373, 7.368, 0)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 7.929,
    height: 0.648,
    transform: "translate(0.242 21.976) rotate(21.925)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 7.232,
    height: 0.648,
    transform: "translate(2.6 12.432)",
    fill: "#d3d3d3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(0 24.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M970.061,356.312a3.519,3.519,0,0,1-1.782.9c-.372-.034-.9-.118-.977-.523a.046.046,0,0,1,.025-.052.086.086,0,0,1-.01-.019,1.929,1.929,0,0,1,.652-2.247c.051-.029.242.041.205.174-.1.362-.389.672-.163,1.023a6.971,6.971,0,0,1,1.977-1.843c.11-.058.431-.18.4.057-.021.151-.391.458-.484.57-.152.181-.547.516-.7.7a.771.771,0,0,1,.361-.2c.19-.058.374.223.3.334a.331.331,0,0,1,.229.511C970.123,355.685,970.45,355.944,970.061,356.312Z",
    transform: "translate(-933.719 -331.447)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M968.213,355.814s-.552.58-.407.74.451-.053.451-.053-.275.307-.137.434.349-.052.349-.052-.021.244.085.264a2.526,2.526,0,0,0,.519-.071s-.505.305-.661.156c-.046-.044-.036-.176-.036-.176s-.249.036-.317-.052a.478.478,0,0,1-.038-.284s-.273-.016-.31-.128A1.021,1.021,0,0,1,968.213,355.814Z",
    transform: "translate(-932.729 -332.212)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M988.619,324.686s-.644,13.6,2.579,15.1c-1.036,1.364-4.909,1.882-8.534.319,0,0,1.479-7.512,1.036-9.465C983.7,330.637,987.44,327.033,988.619,324.686Z",
    transform: "translate(-964.543 -321.246)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M998.536,325.1a21.781,21.781,0,0,1,.309,7.948c-.326,2.746-.341,5.688.939,7.916a40.515,40.515,0,0,1-12.9-1.187c-.81-.212,1.935-15.009,2.6-15.1S998.536,325.1,998.536,325.1Z",
    transform: "translate(-975.768 -321.237)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M994.434,378.457c.99,7.693-6.276,49.08-6.276,49.08H987.6s-.984-42.542-.958-44.129,4.556-6.565,4.556-6.565Z",
    transform: "translate(-970.452 -339.62)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M996.336,376.843s-3.553,42.974-3.5,50.694h-.1s-.984-42.542-.958-44.129S996.336,376.843,996.336,376.843Z",
    transform: "translate(-975.587 -339.62)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M993.293,376.808c-4.5,10.6,2.472,50.714,2.472,50.714h.569l3.7-40.331,1.7-1.621.221-8.74Z",
    transform: "translate(-981.205 -339.608)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M1002.363,376.808l1.748.708c-4.075,10.141-.372,43.952,1.039,50.007h-.314S997.863,387.408,1002.363,376.808Z",
    transform: "translate(-990.275 -339.608)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M980.929,346.419c-1.055.394.259,5.612,6.48,14.211,1.594,2.2,3.653-1.063,2.83-2.431s-4.3-7.311-4.3-7.311S982.9,345.685,980.929,346.419Z",
    transform: "translate(-962.436 -328.878)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M985.587,346.411c-1.055.394.259,5.612,6.48,14.211-1.645-5.292-1.731-6.987-2.373-9.3C989.266,349.781,987.554,345.676,985.587,346.411Z",
    transform: "translate(-967.095 -328.869)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6440",
    "data-name": "Path 6440",
    d: "M971.268,365.045c.281.317.928.159,2.29-.868,1.066-.8,6.091-5.717,6.091-5.717l-.726-1.276s-6.1,3.956-6.954,5.1S970.642,364.339,971.268,365.045Z",
    transform: "translate(-945.427 -332.695)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6441",
    "data-name": "Path 6441",
    d: "M994.48,342.173a.8.8,0,0,0,.419.124,1.084,1.084,0,0,0,.417-.091.458.458,0,0,0-.414-.232A.527.527,0,0,0,994.48,342.173Z",
    transform: "translate(-976.316 -327.336)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M999.187,368.178c-6.328,2.144-13.725-.291-13.725-.291s2.228-6.652,2.487-9.411a36.068,36.068,0,0,0-.117-6,19.884,19.884,0,0,0-.634-3.873c-.337-.952.551-1.716,1.328-2.183.168-.1.33-.181.472-.253.317-.155.544-.24.544-.24s.719-.091,2.934-.24a2.1,2.1,0,0,1,1.633.8c2.008,2.137,3.213,7.883,3.173,9.12a1.649,1.649,0,0,1-1.587,1.612C995.948,359.434,999.187,368.178,999.187,368.178Z",
    transform: "translate(-974.346 -328.642)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6443",
    "data-name": "Path 6443",
    d: "M994.219,363.27a16.3,16.3,0,0,1-3.629-.389,6.205,6.205,0,0,0,3.8,1.431Z",
    transform: "translate(-972.868 -334.702)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M999.329,350.384s.927,7.863.352,10.365-2.338,8.383-2.338,8.383,3.925.936,6.028,1.172a5.374,5.374,0,0,1-2.577-5.185c.391-3.562.337-13.278-.85-15.167S999.329,350.384,999.329,350.384Z",
    transform: "translate(-986.225 -329.886)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(0 19.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6445",
    "data-name": "Path 6445",
    d: "M1017.279,350.78c.549.02.815.472,1.132.882a21.042,21.042,0,0,1,1.221,2.478c-.264.185-.878.126-1.136.32-.06.045-.495-1.619-.656-1.639-.118-.014-.473-.028-.6-.025a1.027,1.027,0,0,1-.7-.247,1.1,1.1,0,0,1-.24-1.284A1.806,1.806,0,0,1,1017.279,350.78Z",
    transform: "translate(-1014.694 -350.166)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6446",
    "data-name": "Path 6446",
    d: "M1019.273,350.225c-.067-.1-.165-.2-.11-.319a.117.117,0,0,1,.12-.073,1.173,1.173,0,0,1,.725.484,1.238,1.238,0,0,0,.805.436,6.839,6.839,0,0,0,.846.049c.148,0,.122.231-.025.229l-.176,0a.119.119,0,0,1-.073.185,1.632,1.632,0,0,1-1.5-.212A4.268,4.268,0,0,1,1019.273,350.225Z",
    transform: "translate(-1018.736 -349.832)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M1019.91,351.376c-.067-.1-.166-.2-.11-.319a.117.117,0,0,1,.12-.073,1.175,1.175,0,0,1,.725.484,1.241,1.241,0,0,0,.805.436,6.839,6.839,0,0,0,.846.049c.148,0,.122.23-.025.229l-.176,0a.119.119,0,0,1-.072.184,1.635,1.635,0,0,1-1.5-.211A4.358,4.358,0,0,1,1019.91,351.376Z",
    transform: "translate(-1019.783 -350.238)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M1019.571,352.579c-.087-.082-.2-.157-.176-.288a.118.118,0,0,1,.1-.1,1.173,1.173,0,0,1,.812.317,1.238,1.238,0,0,0,.88.253,6.743,6.743,0,0,0,.836-.134c.145-.029.168.2.024.229l-.172.035c.062.051.273.308.193.349a2.114,2.114,0,0,1-1.732-.04A4.338,4.338,0,0,1,1019.571,352.579Z",
    transform: "translate(-1019.281 -350.663)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6449",
    "data-name": "Path 6449",
    d: "M1019.886,350.714c-.067-.1-.166-.2-.11-.319a.117.117,0,0,1,.12-.073,1.175,1.175,0,0,1,.725.484,1.241,1.241,0,0,0,.806.436,6.821,6.821,0,0,0,.845.049c.148,0,.122.23-.025.229l-.176,0a.119.119,0,0,1-.072.185,1.637,1.637,0,0,1-1.5-.212A4.362,4.362,0,0,1,1019.886,350.714Z",
    transform: "translate(-1019.744 -350.005)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6450",
    "data-name": "Path 6450",
    d: "M1018.74,350.109a.117.117,0,0,1,.106-.148,2.73,2.73,0,0,1,1.1.1,2.437,2.437,0,0,1,.752.739.344.344,0,0,1-.129.244c-.424.082-.569-.28-.9-.455S1018.874,350.565,1018.74,350.109Z",
    transform: "translate(-1017.431 -349.876)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M1021.344,351.5a1.287,1.287,0,0,0-.029,1.375A5.141,5.141,0,0,1,1021.344,351.5Z",
    transform: "translate(-1019.602 -350.419)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M1019.832,351.368a.8.8,0,0,0,.319.811s-.389-.28-.436-.444A.405.405,0,0,1,1019.832,351.368Z",
    transform: "translate(-1017.487 -350.373)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M1009.942,347.6a16.224,16.224,0,0,1-1.84,5.13,58.655,58.655,0,0,1-4.955,7.967c-1.593,2.2-3.653-1.063-2.83-2.429s4.3-7.313,4.3-7.313,2.157-3.685,4.016-4.417a1.486,1.486,0,0,1,.634-.117,1.163,1.163,0,0,1,.363.065C1009.884,346.586,1010,346.961,1009.942,347.6Z",
    transform: "translate(-994.616 -328.903)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M1015.425,363.726c-.4.149-1.045.04-1.769-1.5-.566-1.208-2.56-8.235-2.56-8.235l1.041-.96s3.735,6.519,3.957,7.934S1016.309,363.394,1015.425,363.726Z",
    transform: "translate(-1007.979 -331.23)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M998.914,348.04c-.162.823-.738,1.775-1.716,1.367a8.713,8.713,0,0,1-1.847-1.425c-.258-.214-.525-.427-.784-.641-.382-.311-.764-.622-1.146-.927-.052-.045-.11-.091-.162-.136a1.487,1.487,0,0,1,.634-.117c.317-.155.544-.24.544-.24s.719-.091,2.934-.24a2.1,2.1,0,0,1,1.633.8A5.074,5.074,0,0,1,998.914,348.04Z",
    transform: "translate(-979.242 -328.642)",
    fill: "#684488"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M1011.317,353.467s-1.1,3.237-5.584,9.458c-.5.69-1.425,2.038-2.794.112a20.872,20.872,0,0,1-1.213-3.482s1.775,4.213,2.693,3.809S1011.317,353.467,1011.317,353.467Z",
    transform: "translate(-997.01 -331.385)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M1011.26,360.228a9.157,9.157,0,0,0,.613,1.213,13.852,13.852,0,0,1,.488-3.088Z",
    transform: "translate(-1004.23 -333.107)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6458",
    "data-name": "Path 6458",
    d: "M998.733,339.789a24.358,24.358,0,0,0-.015,4.2c-.65,1.98-3.753.035-3.753.035.045-.413.062-.914.064-1.414.005-1.023-.058-2.044-.08-2.339a.261.261,0,0,0,0-.048.232.232,0,0,0,0-.034Z",
    transform: "translate(-980.035 -326.567)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6459",
    "data-name": "Path 6459",
    d: "M998.837,340.147c-.023.161-.043.312-.056.452a6.863,6.863,0,0,0-.052,1.124c0,.365.014.931.012,1.315-.813.7-3.024-.861-3.662-1.82-.031-1.042-.15-2.181-.15-2.181Z",
    transform: "translate(-980.127 -326.302)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6460",
    "data-name": "Path 6460",
    d: "M988.937,326.325s-.191,5.5.94,7.481,3.43,3.659,4.213,3.522c2.074-.363,3.878-5.485,3.827-9.12C997.854,323.686,993.666,321.638,988.937,326.325Z",
    transform: "translate(-975.319 -320.885)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6461",
    "data-name": "Path 6461",
    d: "M996.6,331.97c.094-.549.429-.91.769-.811.357.106.59.683.5,1.3s-.475,1-.836.825A1.258,1.258,0,0,1,996.6,331.97Z",
    transform: "translate(-980.244 -323.521)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6462",
    "data-name": "Path 6462",
    d: "M991.1,332.071c.025-.558.262-1,.543-.994s.516.5.49,1.1-.29,1.05-.581,1S991.078,332.63,991.1,332.071Z",
    transform: "translate(-970.949 -323.498)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6463",
    "data-name": "Path 6463",
    d: "M992.133,331.573a2.35,2.35,0,0,0-1.6-.365.589.589,0,0,1,.63-.365C991.661,330.88,992.133,331.573,992.133,331.573Z",
    transform: "translate(-970.577 -323.414)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6464",
    "data-name": "Path 6464",
    d: "M996.326,331.535a2.365,2.365,0,0,1,1.732-.11.842.842,0,0,0-.784-.5C996.708,330.907,996.326,331.535,996.326,331.535Z",
    transform: "translate(-980.253 -323.445)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6465",
    "data-name": "Path 6465",
    d: "M993.887,334.512a6.237,6.237,0,0,0,.345,1.506c.018.056.039.115.051.164s0-.014.023-.011-.094.068-.2.1c-.221.064-.479.12-.742.188a1.722,1.722,0,0,0,.8.187.67.67,0,0,0,.5-.19.439.439,0,0,0,.079-.376c-.014-.076-.032-.142-.051-.208A3.582,3.582,0,0,0,993.887,334.512Z",
    transform: "translate(-975.036 -324.708)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(17.761 12.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6466",
    "data-name": "Path 6466",
    d: "M993.311,339.154s1.249.56,2,.043c0,0-.1,1.516-.751,1.5S993.524,339.973,993.311,339.154Z",
    transform: "translate(-993.311 -339.154)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6467",
    "data-name": "Path 6467",
    d: "M998.966,328.354c.238.059.164.471-.07.534a7.144,7.144,0,0,0-2.571.79C996.235,329.722,997.886,328.089,998.966,328.354Z",
    transform: "translate(-981.305 -322.528)",
    fill: "#e38038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6468",
    "data-name": "Path 6468",
    d: "M989.094,328.354c-.238.059-.164.471.07.534a7.144,7.144,0,0,1,2.571.79C991.824,329.722,990.173,328.089,989.094,328.354Z",
    transform: "translate(-969.154 -322.528)",
    fill: "#e38038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6469",
    "data-name": "Path 6469",
    d: "M998.608,346.19c-.524,1.246-2.939.367-3.674-.062-.361-.211-.636.163-.277.372,1.178.687,3.978,1.51,4.307-.27C999,346.04,998.724,345.913,998.608,346.19Z",
    transform: "translate(-979.973 -328.765)",
    fill: "#ca5780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6470",
    "data-name": "Path 6470",
    d: "M990.038,391.693l3.05-2.107-3.05.378Z",
    transform: "translate(-971.211 -344.11)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(16.193 85.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6471",
    "data-name": "Path 6471",
    d: "M991.41,451.51c-.591.239-1.071,2.246-1.071,2.246h5.489a13.286,13.286,0,0,1-2.527-1.332C992.036,451.6,991.873,451.323,991.41,451.51Z",
    transform: "translate(-990.339 -451.454)",
    fill: "#7b519b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 5.489,
    height: 0.428,
    transform: "translate(0 2.302)",
    fill: "#5d3e4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(10.172 85.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M1004.053,451.51c.591.239,1.071,2.246,1.071,2.246h-5.489a13.264,13.264,0,0,0,2.527-1.332C1003.428,451.6,1003.591,451.323,1004.053,451.51Z",
    transform: "translate(-999.635 -451.454)",
    fill: "#7b519b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 5.489,
    height: 0.428,
    transform: "translate(0.001 2.302)",
    fill: "#5d3e4a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6473",
    "data-name": "Path 6473",
    d: "M988.165,325.174a9.9,9.9,0,0,1,.057,3.963,2.439,2.439,0,0,0-1.5-.318s-3.229-3.349-1.837-5.993c0-.006.006-.006.006-.012a5.689,5.689,0,0,1,2.2-2.314,7.886,7.886,0,0,1,8.716.445c3.894-1.571,3.729,5.124,3.729,5.124C994.213,322.763,988.165,325.174,988.165,325.174Z",
    transform: "translate(-974.094 -319.375)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6474",
    "data-name": "Path 6474",
    d: "M1008.643,340.586c-3.988,2.09-9.7-.8-9.7-.8,2.426-3.461,1.967-10.7,4.384-15.086,0-.006.006-.006.006-.012a9.708,9.708,0,0,0,3.332,6.322C1006.159,332.964,1007.73,338.527,1008.643,340.586Z",
    transform: "translate(-992.534 -321.246)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(12.431 8.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6475",
    "data-name": "Path 6475",
    d: "M1002.885,333.038c-.405-.442-1.861-1.457-2.174-.5-.392,1.2,1.182,4.081,2.242,2.56A1.911,1.911,0,0,0,1002.885,333.038Z",
    transform: "translate(-1000.65 -332.141)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6476",
    "data-name": "Path 6476",
    d: "M1002.943,333.853s-1.133-.978-1.174-.319a1.618,1.618,0,0,0,.9,1.634,1.488,1.488,0,0,1-.221-.972C1002.542,333.691,1002.943,333.853,1002.943,333.853Z",
    transform: "translate(-1001.094 -332.551)",
    fill: "#f29866"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(318.941 679.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(168.387 50.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M999.949,672.755c-3.055,6.868-14.169,10.19-32.715,8.312-13.071-1.321-15.18-6.5-13.916-14.082,1.033-6.182,12-11.923,12-11.923,3.156-8.774,10.1-19.4,19.549-19.116h.008a13.166,13.166,0,0,1,3.286.527,17.025,17.025,0,0,1,10.817,9.612,27.509,27.509,0,0,1,1.676,4.643C1002.9,659.207,1001.682,668.856,999.949,672.755Z",
    transform: "translate(-953.001 -635.94)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M995.893,672.292s-9.7-6.582-20.919-5.546C974.975,666.745,985.117,660.406,995.893,672.292Z",
    transform: "translate(-960.742 -646.198)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    d: "M985.075,682.862c-.578,3.379-6.842,5.127-13.993,3.906s-12.48-4.952-11.9-8.33,4.364-6.4,13.993-3.905C980.194,676.354,985.652,679.483,985.075,682.862Z",
    transform: "translate(-955.162 -649.212)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M990.98,642.245c1.112-3.242,5.424-4.7,9.631-3.258s6.715,5.241,5.6,8.484-4.155,6.025-9.631,3.258C992.59,648.712,989.868,645.488,990.98,642.245Z",
    transform: "translate(-966.292 -636.818)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    d: "M1000.649,650.734v0l-.008-.028q-.15-.561-.321-1.114c-.02-.067-.042-.132-.063-.2q-.145-.459-.305-.909l-.091-.251q-.162-.445-.339-.881c-.028-.068-.054-.137-.082-.2-.148-.357-.3-.71-.466-1.057a17.025,17.025,0,0,0-10.817-9.612,13.111,13.111,0,0,0-3.286-.527h-.008s14.819,2.133,14.146,19.424c-.554,14.263-9.913,22.625-22.7,23.169-24.553,1.045-22.989-11.555-22.989-11.555-1.263,7.583.845,12.761,13.916,14.082,18.545,1.878,29.66-1.444,32.715-8.312C1001.678,668.86,1002.9,659.21,1000.649,650.734Z",
    transform: "translate(-953.001 -635.944)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(166.92 26.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M985.351,604.737s-1.739,1.437-1.28,5.474c.734,6.451-2.829,7.136-.915,10.321.941,1.566,4.044,1.871,5.182,1.835s3.621-11.985,3.621-11.985Z",
    transform: "translate(-961.955 -600.625)",
    fill: "#872f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M986.67,603.333s-1,6.594-.326,8.734c.832,2.637.334,5.5,1.722,7.85,0,0,8.835-1.615,9.433-2.2s-2.463-16-3.13-16.1S986.67,603.333,986.67,603.333Z",
    transform: "translate(-963.197 -599.525)",
    fill: "#71201c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M966.492,638.516c-.135-.174-.258-.35-.406-.506a.08.08,0,0,0-.01-.019,2.893,2.893,0,0,0-.706-.724,4.2,4.2,0,0,0-1.1-.356c-.076-.021-.131.025-.117.08.1.358.573.375.893.58a2.753,2.753,0,0,0-.361.03,1.745,1.745,0,0,1-.586-.439,1.577,1.577,0,0,0-.7-.534.116.116,0,0,0-.126.021c-.064.074.028.17.089.258.042.062.091.127.136.192a1.28,1.28,0,0,0-.52-.345.118.118,0,0,0-.126.021c-.064.074.029.17.089.258l.031.043a.352.352,0,0,0-.039-.018.115.115,0,0,0-.126.021c-.064.074.028.17.089.257.08.117.165.241.256.363a1.277,1.277,0,0,0-.194-.057.093.093,0,0,0-.109.043c-.037.087.076.172.157.253a5.508,5.508,0,0,0,.729.646,4.724,4.724,0,0,0,2.633.577s0,0,0,0A.348.348,0,0,0,966.492,638.516Z",
    transform: "translate(-954.983 -611.856)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    d: "M955.939,661.323c-1.265,2.085,4.992,25.508,4.992,25.508l1.4.1-1.24-20.542s9.684-.338,10.878-2.384c1.12-1.919,1.12-5.3,1.12-5.3-.548.026,2.914-2.361,2.914-2.361C967.7,656.348,956.9,659.741,955.939,661.323Z",
    transform: "translate(-952.509 -618.806)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M963.237,667.07l1.233,20.511-.955.174s-2.22-23.139-1.525-25.044c1.264-3.466,12.4-4.441,12.4-4.441l-5.835,8.225S963.831,667.32,963.237,667.07Z",
    transform: "translate(-954.652 -619.484)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M964.169,662.91c-.689,2.02,12.845,24.1,12.845,24.1l1.516.139-7.51-20.731s12.768,1.244,13.962-.8c1.12-1.919,1.774-7.521,1.774-7.521-.549.025-5.511-1.142-5.511-1.142C972.936,656.952,964.775,661.133,964.169,662.91Z",
    transform: "translate(-955.459 -619.02)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M972.484,664.916c-.688,2.02,8.672,22.2,8.672,22.2l.3.028-7.51-20.731s12.768,1.244,13.962-.8c1.12-1.919,1.774-7.521,1.774-7.521-.549.025-5.511-1.142-5.511-1.142,1.807,2.805,2.316,6.248.374,6.668C978.715,664.879,972.94,663.583,972.484,664.916Z",
    transform: "translate(-958.384 -619.02)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(20.757 65.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M982.822,700.584c.2-.606,2.169-1.22,2.169-1.22l.37,5.477a13.3,13.3,0,0,0-1.5-2.432C982.95,701.2,982.666,701.058,982.822,700.584Z",
    transform: "translate(-982.781 -699.355)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 5.489,
    height: 0.428,
    transform: "matrix(-0.067, -0.998, 0.998, -0.067, 2.571, 5.506)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(5.064 67.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M962.972,702.321c.591.239,1.071,2.246,1.071,2.246h-5.49a13.31,13.31,0,0,0,2.527-1.332C962.346,702.408,962.509,702.134,962.972,702.321Z",
    transform: "translate(-958.553 -702.265)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 5.49,
    height: 0.427,
    transform: "translate(0 2.302)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M988.308,625.88c1.054.394-.26,5.612-6.481,14.211-1.594,2.2-3.653-1.063-2.83-2.431s4.3-7.311,4.3-7.311S986.341,625.145,988.308,625.88Z",
    transform: "translate(-960.625 -608.048)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6510",
    "data-name": "Path 6510",
    d: "M989.949,625.872c1.054.394-.26,5.612-6.481,14.211,1.645-5.292,1.731-6.987,2.374-9.3C986.27,629.242,987.983,625.136,989.949,625.872Z",
    transform: "translate(-962.266 -608.04)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6511",
    "data-name": "Path 6511",
    d: "M977.127,645.117c-.225.359-.889.312-2.4-.473-1.185-.613-6.961-4.62-6.961-4.62l.242-1.4s6.931,2.9,7.969,3.886S977.626,644.315,977.127,645.117Z",
    transform: "translate(-956.734 -612.565)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6512",
    "data-name": "Path 6512",
    d: "M993.526,621.633a.8.8,0,0,1-.418.124,1.08,1.08,0,0,1-.417-.091.459.459,0,0,1,.413-.233A.527.527,0,0,1,993.526,621.633Z",
    transform: "translate(-965.515 -606.507)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M981.58,646a25.563,25.563,0,0,0,11.889,1.06,71.96,71.96,0,0,1,.82-15.131c.293-1.652.383-3.161.635-3.873.337-.952-.551-1.716-1.328-2.183-.169-.1-.331-.181-.473-.253-.317-.155-.544-.24-.544-.24s-.719-.091-2.934-.24a2.1,2.1,0,0,0-1.632.8c-2.009,2.138-3.213,7.883-3.174,9.12a1.651,1.651,0,0,0,1.587,1.613C986.174,638.895,981.58,646,981.58,646Z",
    transform: "translate(-961.601 -607.813)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M988.969,642.73a16.291,16.291,0,0,0,3.628-.389,6.2,6.2,0,0,1-3.8,1.432Z",
    transform: "translate(-964.145 -613.872)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M997.526,629.845s-.973,5.964-1.2,10.937c-.119,2.566,0,7.525,0,7.525a21.936,21.936,0,0,1-6.641.1s4.989.134,4.6-3.428,1.445-13.677,2.633-15.567S997.526,629.845,997.526,629.845Z",
    transform: "translate(-964.456 -609.057)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M996.1,652.967c-.52-1.295-3.685.036-4.407.559a.261.261,0,0,0,.06.449c-.051.036-.1.069-.152.107-.243.185,0,.6.242.415.016-.012.034-.021.05-.034a.264.264,0,0,0,.381.068c.067-.053.142-.1.212-.146.027.134.181.085.327.024.56-.234.913-.455,1.442-.639a2.855,2.855,0,0,0,1.561-.009A.53.53,0,0,0,996.1,652.967Z",
    transform: "translate(-965.096 -617.422)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M998.354,627.063a16.229,16.229,0,0,0,1.839,5.13,58.623,58.623,0,0,0,4.955,7.968c1.593,2.2,3.653-1.063,2.831-2.429s-4.3-7.313-4.3-7.313-2.156-3.685-4.015-4.417a1.487,1.487,0,0,0-.635-.117,1.16,1.16,0,0,0-.363.065C998.412,626.047,998.3,626.422,998.354,627.063Z",
    transform: "translate(-967.505 -608.074)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M1007.661,645.531c-.2-.375-.863-.377-2.432.293-1.227.525-7.284,4.092-7.284,4.092l.139,1.41s7.127-2.378,8.235-3.286S1008.1,646.368,1007.661,645.531Z",
    transform: "translate(-967.367 -614.907)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M991.588,627.5c.162.823.739,1.775,1.717,1.367a8.736,8.736,0,0,0,1.846-1.425c.259-.214.525-.427.784-.641.382-.31.765-.622,1.147-.926.052-.045.11-.091.162-.136a1.486,1.486,0,0,0-.635-.117c-.317-.155-.544-.24-.544-.24s-.719-.091-2.934-.24a2.1,2.1,0,0,0-1.632.8A5.062,5.062,0,0,0,991.588,627.5Z",
    transform: "translate(-965.085 -607.813)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M999.936,632.928s.735,2.713,5.216,8.933c-.623.336-4.293,2.415-4.293,2.415s6.1-1.711,5.491-2.505C1005.215,640.3,999.936,632.928,999.936,632.928Z",
    transform: "translate(-968.068 -610.556)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(0 28.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(2.271 9.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 18.394,
    height: 0.806,
    transform: "translate(0 1.895)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M982.641,660.668l8.313-1.284v-.805l-8.313,1.284Z",
    transform: "translate(-964.247 -657.967)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M980.95,658.245l-20.873-.611-5.835,1.9h18.394Z",
    transform: "translate(-954.242 -657.634)",
    fill: "#dedede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M953.8,654.119h18.321l-2.412-11.28a.69.69,0,0,0-.663-.563h-16.5a1.07,1.07,0,0,0-.995,1.326Z",
    transform: "translate(-951.015 -642.276)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M953.08,654.119H971.4l-2.412-11.28a.69.69,0,0,0-.663-.563H951.478a.779.779,0,0,0-.724.965Z",
    transform: "translate(-950.735 -642.276)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M953.08,654.119h14.175l-9.645-11.843h-6.132a.779.779,0,0,0-.724.965Z",
    transform: "translate(-950.735 -642.276)",
    fill: "#dedede"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M993.156,619.25a24.436,24.436,0,0,1,.016,4.2c.65,1.98,3.753.035,3.753.035-.045-.413-.063-.914-.065-1.414,0-1.023.058-2.044.08-2.34a1.994,1.994,0,0,0,0-.082Z",
    transform: "translate(-965.679 -605.738)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M993.137,619.607c.023.161.043.312.056.453a6.789,6.789,0,0,1,.052,1.124c0,.365-.014.931-.012,1.315.813.7,3.024-.862,3.662-1.821.03-1.042.15-2.18.15-2.18Z",
    transform: "translate(-965.673 -605.473)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M996.115,605.785s.191,5.5-.94,7.482-3.429,3.658-4.213,3.522c-2.074-.362-3.877-5.484-3.827-9.12C987.2,603.146,991.385,601.1,996.115,605.785Z",
    transform: "translate(-963.558 -600.056)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(24.631 8.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M996.031,612.119c-.094-.549-.429-.91-.769-.811-.357.106-.59.683-.5,1.3s.475,1,.836.825A1.258,1.258,0,0,0,996.031,612.119Z",
    transform: "translate(-990.869 -611.06)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M990.3,612.221c-.025-.558-.262-1-.543-.994s-.516.5-.49,1.1.29,1.05.581,1S990.329,612.78,990.3,612.221Z",
    transform: "translate(-988.941 -611.038)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M988.762,611.815a2.35,2.35,0,0,1,1.529-.589.59.59,0,0,0-.675-.272C989.131,611.063,988.762,611.815,988.762,611.815Z",
    transform: "translate(-988.762 -610.935)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M996.161,611.8a2.365,2.365,0,0,0-1.694-.374.84.84,0,0,1,.85-.37C995.881,611.118,996.161,611.8,996.161,611.8Z",
    transform: "translate(-990.772 -610.974)",
    fill: "#503d39"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M991.983,614.475a6.268,6.268,0,0,1-.345,1.506c-.018.056-.039.115-.051.165s0-.014-.023-.011.094.068.2.1c.221.063.479.12.742.188a1.722,1.722,0,0,1-.8.187.671.671,0,0,1-.5-.19.443.443,0,0,1-.08-.376c.014-.076.033-.141.052-.208A3.554,3.554,0,0,1,991.983,614.475Z",
    transform: "translate(-964.959 -604.055)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(26.374 13.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M993.513,618.645s-1.219.821-2.059.472c0,0,.451,1.569.931,1.494C992.992,620.516,993.477,619.49,993.513,618.645Z",
    transform: "translate(-991.454 -618.645)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M994.434,609.092c-.229.088-.1.487.137.521a7.155,7.155,0,0,1,2.65.458C997.317,610.1,995.472,608.692,994.434,609.092Z",
    transform: "translate(-966.087 -602.134)",
    fill: "#5c3339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M990.063,609.048c.231.083.115.484-.124.525a7.149,7.149,0,0,0-2.638.522C987.207,610.129,989.016,608.673,990.063,609.048Z",
    transform: "translate(-963.615 -602.122)",
    fill: "#5c3339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M993.058,625.651c.525,1.245,2.939.367,3.674-.062.361-.21.636.163.277.373-1.178.687-3.979,1.509-4.307-.27C992.667,625.5,992.942,625.374,993.058,625.651Z",
    transform: "translate(-965.518 -607.936)",
    fill: "#f0c960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M993.856,603.7a9.882,9.882,0,0,0-.057,3.963,2.437,2.437,0,0,1,1.5-.318s3.229-3.349,1.837-5.993c0-.006-.006-.006-.006-.012a5.466,5.466,0,0,0-2.2-2.314,6.839,6.839,0,0,0-5.287-.176c-5.123-1.49-7.532,3.407-6.365,5.031C984.879,606.111,993.856,603.7,993.856,603.7Z",
    transform: "translate(-962.097 -598.388)",
    fill: "#872f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M1001.922,602.968a28.264,28.264,0,0,1,1.5,5.995c.214,2.543,5.545,7.781,1.783,12.012-1.036,1.165-5.563,1.928-7.491.648s-1.067-3.711.012-5A7.09,7.09,0,0,0,999,611.54c-.974-4.119-.353-6.224-.353-6.224Z",
    transform: "translate(-966.883 -600.002)",
    fill: "#872f26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(31.171 8.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M999.2,612.5c.406-.443,1.861-1.457,2.174-.5.393,1.2-1.181,4.081-2.242,2.56A1.91,1.91,0,0,1,999.2,612.5Z",
    transform: "translate(-998.859 -611.601)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M999.976,613.314s1.132-.979,1.173-.319a1.618,1.618,0,0,1-.9,1.634,1.49,1.49,0,0,0,.222-.972C1000.378,613.152,999.976,613.314,999.976,613.314Z",
    transform: "translate(-999.253 -612.012)",
    fill: "#f29866"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(62.497 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(0 86.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M792.952,691.817c-.7-.322-2.715.68-2.715.68l4.2,4.941s-.521-1.549-.98-3.117C792.928,692.527,793.5,692.069,792.952,691.817Z",
    transform: "translate(-789.771 -691.754)",
    fill: "#e8a148"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 6.482,
    height: 0.58,
    transform: "translate(4.195 6.071) rotate(-130.332)",
    fill: "#e38038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(28.212 94.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M834.344,703.784c-.695.328-1.224,2.518-1.224,2.518l6.482-.039s-1.522-.6-3.018-1.253C834.873,704.259,834.889,703.527,834.344,703.784Z",
    transform: "translate(-833.09 -703.732)",
    fill: "#e8a148"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 6.482,
    height: 0.58,
    transform: "translate(6.485 3.128) rotate(179.662)",
    fill: "#e38038"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M831.641,626.1c2.3,13.4-.74,50.805-.74,50.805l-1.885.264s-8.2-35.393-8.8-36.879.289-11.3.289-11.3Z",
    transform: "translate(-800.26 -581.887)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M825.271,640.847c-.5-1.383-5.528-8.4-5.528-8.4s-.229,8.591.365,10.08,8.8,36.879,8.8,36.879l1.35-.188C828.963,676.192,825.826,642.379,825.271,640.847Z",
    transform: "translate(-800.15 -584.123)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M794.107,669.83l16.055-15.544,6.078-16.467,2.753-2.111-.441-10.176-14.191,1.132-1.106,26.028-10.839,15.816Z",
    transform: "translate(-790.539 -581.686)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M826.189,645.552l-4.164-2.919,4.026.9L830,641.31Z",
    transform: "translate(-800.97 -587.245)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M805.266,654.423s.451-15.906,3.28-20.955c1.534-2.74,14.1-3.254,14.1-3.254l-2.233-5.041-16.05,1.365-1.106,26.028-10.839,15.816.959.751Z",
    transform: "translate(-790.539 -581.56)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(45.985 25.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M865.909,599.059a5.169,5.169,0,0,0-2.939,1.078c-.864.551-1.639.934-2.449,1.49a10.207,10.207,0,0,0,2.267,2.108,16.521,16.521,0,0,0,2.982-1.438c.267.006,1.222.2,1.679-.083a1.68,1.68,0,0,0,.618-2.252A4.531,4.531,0,0,0,865.909,599.059Z",
    transform: "translate(-860.514 -597.986)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M873.834,599.055c.188-.129.02-.737-.2-.7a5.58,5.58,0,0,0-1.731.684,3.605,3.605,0,0,1-1.963.405c-.632-.032-1.266-.12-1.889-.206-.328-.045-.365.315-.04.361l.387.055c-.135.079-.1.244.083.308a5.082,5.082,0,0,0,3.4.171A12.392,12.392,0,0,0,873.834,599.055Z",
    transform: "translate(-863.075 -597.738)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M874.685,601.271c.188-.129.061-.648-.058-.655a3.227,3.227,0,0,0-1.8.506,3.605,3.605,0,0,1-1.964.405c-.632-.032-1.266-.12-1.888-.206-.328-.045-.365.315-.04.361l.387.055c-.135.079-.1.244.083.308a5.082,5.082,0,0,0,3.4.171A11.237,11.237,0,0,0,874.685,601.271Z",
    transform: "translate(-863.4 -598.533)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M873.4,602.916c.225-.1.516-.175.51-.387,0-.079,0-.3-.118-.322a3.876,3.876,0,0,0-1.993.359,3.866,3.866,0,0,1-2.052.1c-.61-.126-1.206-.307-1.792-.484-.308-.094-.454.252-.148.345l.364.111c-.157.057-.733.385-.573.474a6.538,6.538,0,0,0,3.845.516A11.214,11.214,0,0,0,873.4,602.916Z",
    transform: "translate(-862.998 -599.08)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M874.911,600.225c.188-.129-.034-.685-.287-.643a4.436,4.436,0,0,0-1.575.51,3.6,3.6,0,0,1-1.963.4c-.633-.032-1.266-.119-1.889-.205-.328-.045-.365.315-.039.361l.387.054c-.135.08-.1.245.083.309a5.082,5.082,0,0,0,3.4.171A11.3,11.3,0,0,0,874.911,600.225Z",
    transform: "translate(-863.48 -598.17)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M870.488,598.194c.12-.081.039-.712-.229-.752a5.672,5.672,0,0,0-2.5.285,9.793,9.793,0,0,0-2.5,1.495c-.12.115.736.006.874.053a.2.2,0,0,0,.169.155c.948.164,1.3-.467,2.046-.758S869.918,598.576,870.488,598.194Z",
    transform: "translate(-862.181 -597.403)",
    fill: "#f5b379"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M826.143,597.327s3.474,9.329,11.823,12.013c3.927,1.262,14.54-8.146,14.54-8.146l-2.633-4.61s-9.413,5.354-9.894,5.277c-1.295-.206-6.322-10.647-10.844-11.66C827.248,589.778,825.4,593.912,826.143,597.327Z",
    transform: "translate(-802.361 -569.229)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M832.834,594.631s3.529,12.472,7.254,13.605c2.748.836,13.985-5.471,13.985-5.471s-9.289,8.751-13.878,8.277-9.769-7.611-9.769-7.611Z",
    transform: "translate(-803.929 -570.8)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M817.586,588.127c3.7-.139,6.277,1.2,7.1,3.348,4.29,11.251,4.443,24.11,4.443,24.11s-12.465,3.252-19.364,1.9c0,0-2.08-19.595.253-25.241C811.612,588.379,814.931,588.226,817.586,588.127Z",
    transform: "translate(-796.348 -568.505)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M828.711,589.168c.815-.081,2.128.527,2.948,2.674,4.291,11.251,5.9,24.833,5.9,24.833a9.741,9.741,0,0,1-2.807.524S833.308,592.987,828.711,589.168Z",
    transform: "translate(-803.325 -568.873)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M817.411,588.132c1.643,6.622,4.963,29.837,4.963,29.837a32.456,32.456,0,0,1-13.642.639s-1.226-20.709,1.106-26.354C811.437,588.384,814.756,588.232,817.411,588.132Z",
    transform: "translate(-796.173 -568.511)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M825.717,581.657c-.074.187-.143.364-.193.529a9.047,9.047,0,0,0-.319,1.325,10.15,10.15,0,0,0-.148,1.222,11.434,11.434,0,0,0,.045,2.11c-3.457,1.706-7.2-.643-7.2-.643a11.332,11.332,0,0,0,.4-1.665,25.576,25.576,0,0,0,.313-2.781.23.23,0,0,0,.005-.056.212.212,0,0,0,.006-.04Z",
    transform: "translate(-799.516 -566.23)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M825.933,581.657c-.074.187-.143.364-.193.529a5.436,5.436,0,0,0-.319,1.325,10.15,10.15,0,0,0-.148,1.222,8.49,8.49,0,0,1-4.844.722,4.586,4.586,0,0,1-1.916-.921,25.581,25.581,0,0,0,.313-2.781.232.232,0,0,0,.005-.056.21.21,0,0,0,.007-.04h7.1Z",
    transform: "translate(-799.732 -566.229)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M816.326,587.6a12.394,12.394,0,0,0,6.418,1.9,11.2,11.2,0,0,0-.826,2.262S817.154,590.42,816.326,587.6Z",
    transform: "translate(-798.962 -568.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M827.838,589.1a2.757,2.757,0,0,1-1.605.908l1.753,1.582s.258-2.123.233-2.4S827.838,589.1,827.838,589.1Z",
    transform: "translate(-802.452 -568.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M812.664,605.726s-1.7,5.684,0,9.732c1.562,3.711,1.713,7.164,9.8,7.971a29.021,29.021,0,0,1-13.642.639s-.365-15.092,0-19.933C808.951,602.4,812.664,605.726,812.664,605.726Z",
    transform: "translate(-796.26 -573.972)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M816.576,572.418s.567,3.775,1.907,4.52,6.047.808,7.047-.389.81-11.065.436-11.834-6.882-3.625-9.091-.479S816.576,572.418,816.576,572.418Z",
    transform: "translate(-798.779 -559.583)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M826.378,559.135c-1.384-1.538-5.069-1.45-8.479-1.038-2.808.339-4.664,3.715-4.626,3.866-.7.229-1.255,1.975-1.021,3.205.877,4.61,3.22,5.417,3.66,5.294,2.042-.572,2.22-4.378,1.088-7.3a14.788,14.788,0,0,1,5.283.026c.86.2,3.459.475,4.335-.052C827.92,562.356,827.14,559.982,826.378,559.135Z",
    transform: "translate(-797.508 -557.839)",
    fill: "#5d3e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M821.469,567.3a6.5,6.5,0,0,1,3.02-.308,1.744,1.744,0,0,1,.008,1.31,13.016,13.016,0,0,1-2.913-.2A1.748,1.748,0,0,1,821.469,567.3Z",
    transform: "translate(-800.766 -561.038)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M831.421,567.817a6.069,6.069,0,0,0-2.79-.827,1.748,1.748,0,0,0-.181,1.282,11.99,11.99,0,0,0,2.757.307A1.766,1.766,0,0,0,831.421,567.817Z",
    transform: "translate(-803.214 -561.054)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M823.922,571.865c.094.549.429.91.769.811.357-.106.589-.683.5-1.3s-.475-1-.836-.826A1.258,1.258,0,0,0,823.922,571.865Z",
    transform: "translate(-801.629 -562.304)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M829.8,571.8c.025.558.262,1,.543.994s.516-.5.49-1.1-.291-1.05-.582-1S829.774,571.245,829.8,571.8Z",
    transform: "translate(-803.707 -562.368)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(23.547 14.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M825.871,580.081a4.244,4.244,0,0,0,2.869-.175s0,1.518-.955,1.78S826.266,580.872,825.871,580.081Z",
    transform: "translate(-825.871 -579.906)",
    fill: "#4c2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M828.739,579.906a2.531,2.531,0,0,1-.231.68,3.863,3.863,0,0,1-2.287.148,4.744,4.744,0,0,1-.35-.653A4.671,4.671,0,0,0,828.739,579.906Z",
    transform: "translate(-825.871 -579.906)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(24.385 10.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M828.144,573.86s.9,1.969.7,2.491-1.674.227-1.674.227Z",
    transform: "translate(-827.165 -573.86)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M828.144,573.86a4.719,4.719,0,0,1,.949,2.043,1.738,1.738,0,0,1,.01.327.594.594,0,0,1-.172.389.96.96,0,0,1-.651.216,2.6,2.6,0,0,1-1.115-.257,9.785,9.785,0,0,0,1.074-.12.7.7,0,0,0,.361-.159c.038-.017.038-.163.012-.329-.047-.328-.148-.677-.232-1.028S828.208,574.233,828.144,573.86Z",
    transform: "translate(-827.165 -573.86)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(15.37 10.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M815.9,574.17c-.449-.461-2.35-1.008-2.588-.248-.381,1.216,1.088,3.562,2.841,2.611C816.789,576.185,816.286,574.569,815.9,574.17Z",
    transform: "translate(-813.247 -573.544)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M815.971,575.375s-1.393-.913-1.525-.5c-.256.808.891,1.474,1.219,1.591,0,0-.641-.7-.475-1S815.971,575.375,815.971,575.375Z",
    transform: "translate(-813.656 -573.975)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M819.614,564.589a28.549,28.549,0,0,1,4.088-.177c.95.149,4.5,1.128,5.688.129s.317-2.664.317-2.664-.307,2.886-2.4,2.516S821.33,563.239,819.614,564.589Z",
    transform: "translate(-800.12 -559.261)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(10.685 46.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M813.422,635.624a7.663,7.663,0,0,0,.161-2.772c-.24-.881-2.122-1.4-2.706-2.038-.236-.256-.337.139-.6.383-.3.189-.542.558-.374.863.233.422,1.22.43,1.517.8a7.633,7.633,0,0,1,.88,1.086.362.362,0,0,0,.141.148,9.186,9.186,0,0,1-.063,1.428A.527.527,0,1,0,813.422,635.624Z",
    transform: "translate(-807.364 -629.546)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M811.575,636.746a8.587,8.587,0,0,0,.339-2.911c-.126-.974-1.574-1.391-2.062-2.149-.2-.306-.622-.226-.909,0a.768.768,0,0,0-.464.869c.174.482,1.1.554,1.345.995a8.518,8.518,0,0,1,.718,1.282.378.378,0,0,0,.119.176,9.558,9.558,0,0,1-.234,1.413C810.244,637.181,811.395,637.5,811.575,636.746Z",
    transform: "translate(-806.872 -629.812)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M809.93,636.558a7.957,7.957,0,0,0,.678-2.607c-.044-.877-1.385-1.241-1.783-1.94-.161-.282-.565-.229-.85-.042-.306.13-.59.44-.5.758.126.44,1.007.471,1.2.876a7.219,7.219,0,0,1,.575,1.178.331.331,0,0,0,.1.163,8.75,8.75,0,0,1-.4,1.265A.52.52,0,1,0,809.93,636.558Z",
    transform: "translate(-806.523 -629.928)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M808.286,635.938a8.034,8.034,0,0,0,.681-2.447c0-.781-1.229-1.087-1.545-1.724-.128-.257-.481-.227-.736-.073-.271.1-.679.449-.67.755.028,1.016,1.806,1.721,1.816,1.874a9.592,9.592,0,0,1-.445,1.222C807.161,636.136,808.062,636.525,808.286,635.938Z",
    transform: "translate(-806.015 -629.844)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M809.848,630.577l-1.2-1.675-2.151,1.06.431,1.658Z",
    transform: "translate(-806.184 -628.902)",
    fill: "#f5b379"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M806.313,590.217s-11.52,5.817-13.679,14.317c-1.015,4,7.871,13.752,7.871,13.752l4.438-2.915s-5.394-7.678-5.347-8.164c.125-1.305,5.922-4.1,7.395-6.208C807.509,598.153,808.448,593.308,806.313,590.217Z",
    transform: "translate(-790.587 -569.245)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M810.108,606.864s-9.608,2.82-8.637,5.789,6.589,8.582,6.589,8.582-5.456-7.286-5.348-8.164S809.1,608.848,810.108,606.864Z",
    transform: "translate(-793.704 -575.11)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(0 73.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(1.146 4.885)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 2.641,
    height: 8.127,
    transform: "translate(0 4.946)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 2.641,
    height: 10.817,
    transform: "translate(4.713 2.257)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 2.641,
    height: 13.073,
    transform: "translate(9.425)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 2.641,
    height: 9.605,
    transform: "translate(14.137 3.469)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M941.617,579.279l-.13,1.081,2.93.354-3.793,3.046-6.455-4.077-9.556,7.237.657.868,8.955-6.782,6.476,4.089,4.29-3.445-.7,2.637,1.053.281,1.251-4.689Z",
    transform: "translate(-924.613 -579.279)",
    fill: "#cecece"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(828.139 675.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6224",
    "data-name": "Path 6224",
    d: "M730.4,400.108l2.268-3.731-2.228-1.634a11,11,0,0,0,.584-3.786l2.619-.883-1.034-4.239-2.731.42a11,11,0,0,0-2.261-3.092l1.227-2.477-3.731-2.268-1.634,2.228a11.082,11.082,0,0,0-3.786-.585l-.883-2.619-4.239,1.033.42,2.732a11,11,0,0,0-3.092,2.261l-2.476-1.227-2.269,3.731,2.228,1.634a11.062,11.062,0,0,0-.584,3.785l-2.619.883,1.034,4.239,2.731-.42a11.045,11.045,0,0,0,2.261,3.091l-1.227,2.477,3.731,2.269,1.634-2.228a11.018,11.018,0,0,0,3.786.584l.883,2.619,4.239-1.033-.42-2.731a11.058,11.058,0,0,0,3.092-2.261Zm-14.583-2.2a7.881,7.881,0,1,1,10.828-2.639A7.882,7.882,0,0,1,715.819,397.909Z",
    transform: "translate(-533.444 -327.462)",
    fill: "#edf1f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(13.625 55.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 2.772,
    height: 29.792,
    transform: "translate(18.606 10.664)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6227",
    "data-name": "Path 6227",
    d: "M489.705,424.82h.7a2.107,2.107,0,0,0,2.107-2.107v-3.334a2.107,2.107,0,0,0-2.107-2.107h-.7a2.107,2.107,0,0,0-2.107,2.107v3.334A2.107,2.107,0,0,0,489.705,424.82Z",
    transform: "translate(-470.064 -397.486)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6228",
    "data-name": "Path 6228",
    d: "M481.913,386.724H463.2l5.713,23.921h18.923l-3.918-21.579A2.508,2.508,0,0,0,481.913,386.724Z",
    transform: "translate(-461.47 -386.724)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6229",
    "data-name": "Path 6229",
    d: "M482.221,422.393s19.437,1.338,21.97-.624c.689-.532.742-3.465-1.538-3.465h-19Z",
    transform: "translate(-468.17 -397.85)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6230",
    "data-name": "Path 6230",
    d: "M461.883,386.78a1.891,1.891,0,0,1,2.345,1.065l4,19.336h10.584c1.8,0,3.211,2.474,1.709,3.465-2.077,1.37-11.148.371-13.554-.361-3.329-1.012-6.424-21.024-6.424-21.024C460.427,387.941,460.992,386.948,461.883,386.78Z",
    transform: "translate(-460.528 -386.724)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6231",
    "data-name": "Path 6231",
    d: "M479.89,449.564h14.9a1.662,1.662,0,0,0-1.662-1.663H481.553a1.663,1.663,0,0,0-1.663,1.663Z",
    transform: "translate(-467.349 -408.276)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 1.247,
    cy: 1.247,
    r: 1.247,
    transform: "translate(24.242 40.872)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 0.806,
    cy: 0.806,
    r: 0.806,
    transform: "translate(24.682 41.312)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 1.247,
    cy: 1.247,
    r: 1.247,
    transform: "translate(18.745 40.871)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 0.806,
    cy: 0.806,
    r: 0.806,
    transform: "translate(19.186 41.312)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 1.247,
    cy: 1.247,
    r: 1.247,
    transform: "translate(13.248 40.871)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 0.806,
    cy: 0.806,
    r: 0.806,
    transform: "translate(13.69 41.312)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(22.972 31.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6232",
    "data-name": "Path 6232",
    d: "M482.079,351.116c-2.347,2.731-2.65,6.789-2.722,14.145-.047,4.855-3.563,11.631-3.563,11.631s14.263,2.833,23.032-3.769c-4.15-4.46-5.886-12.464-6.35-19.329C492.475,353.794,485.73,346.867,482.079,351.116Z",
    transform: "translate(-475.252 -349.47)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6233",
    "data-name": "Path 6233",
    d: "M494.544,356.1s1.139,15.065,3.147,18.689c0,0-10.27,3.843-12.967,2.213a110.112,110.112,0,0,0,1.761-15.128C490.211,362.239,494.544,356.1,494.544,356.1Z",
    transform: "translate(-478.398 -351.712)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6234",
    "data-name": "Path 6234",
    d: "M515.935,410.683c1.266,2.085,3.842,23.138,3.842,23.138l-1.4.1-6.592-19.2S501.1,413.2,499.9,411.152c-1.12-1.919-1.12-5.3-1.12-5.3.548.026-2.914-2.361-2.914-2.361C504.178,403.491,514.975,409.1,515.935,410.683Z",
    transform: "translate(-482.325 -368.406)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6235",
    "data-name": "Path 6235",
    d: "M511.127,415.4l6.6,19.17.385.383s-4.952-19.955-5.647-21.859c-1.264-3.466-13.492-7.681-13.492-7.681L494,409.576S510.532,415.651,511.127,415.4Z",
    transform: "translate(-481.667 -369.084)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6236",
    "data-name": "Path 6236",
    d: "M506.944,412.27c.689,2.019-6.259,22.218-6.259,22.218l-.931-.263,1.073-19.087s-13.849-1.082-15.043-3.128c-1.12-1.918.2-7.049.2-7.049a36.181,36.181,0,0,0,3.884-.867C495.071,406.065,506.338,410.493,506.944,412.27Z",
    transform: "translate(-478.613 -368.619)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6237",
    "data-name": "Path 6237",
    d: "M502.2,414.638c.688,2.019-2.389,20.444-2.389,20.444l-.062-.385,1.073-19.087s-13.849-1.082-15.043-3.128c-1.12-1.918.2-7.049.2-7.049.548.026,7.524,1.7,7.524,1.7-2.507,1.355-4.64,3.144-2.113,4.189C496.262,413.327,501.8,413.468,502.2,414.638Z",
    transform: "translate(-478.612 -369.091)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6238",
    "data-name": "Path 6238",
    d: "M521.1,396.328a6.571,6.571,0,0,0,.544.376.068.068,0,0,0,.014.017,2.824,2.824,0,0,0,.9.495,3.892,3.892,0,0,0,1.157-.015c.079-.005.118-.072.086-.122-.209-.329-.661-.185-1.029-.283a2.69,2.69,0,0,0,.334-.155,1.641,1.641,0,0,1,.694.245,1.5,1.5,0,0,0,.827.3.116.116,0,0,0,.113-.065c.038-.1-.08-.163-.165-.231-.06-.048-.126-.1-.189-.148a1.2,1.2,0,0,0,.6.173.115.115,0,0,0,.113-.065c.038-.1-.08-.163-.164-.231-.014-.011-.029-.022-.042-.034.014,0,.027.005.041.005a.117.117,0,0,0,.113-.065c.038-.1-.08-.163-.165-.232-.113-.091-.231-.188-.358-.28a1.216,1.216,0,0,0,.2-.009.1.1,0,0,0,.09-.082c.008-.1-.126-.148-.228-.2a5.33,5.33,0,0,0-.894-.408c-.525-.161-2.378-.06-2.683.317,0,0,0,0,0,0A.383.383,0,0,0,521.1,396.328Z",
    transform: "translate(-491.118 -365.5)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6239",
    "data-name": "Path 6239",
    d: "M495.073,375.546c-1.054.394-.06,4.778,6.162,13.377,1.594,2.2,4.472.065,3.65-1.3s-4.8-7.6-4.8-7.6S497.039,374.811,495.073,375.546Z",
    transform: "translate(-481.916 -358.537)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6240",
    "data-name": "Path 6240",
    d: "M495.073,375.538c-1.054.394-.06,4.778,6.162,13.377-1.645-5.292-1.412-6.153-2.055-8.464C498.751,378.908,497.039,374.8,495.073,375.538Z",
    transform: "translate(-481.916 -358.528)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6241",
    "data-name": "Path 6241",
    d: "M505.276,395.707c.005.424,1.157.893,2.859,1.008,1.331.09,7.787-.5,7.787-.5l.518-1.318s-7.429-1.122-8.829-.818S505.266,394.763,505.276,395.707Z",
    transform: "translate(-485.638 -365.073)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6242",
    "data-name": "Path 6242",
    d: "M497.936,393.9c-5.973,4.633-13.5,2.83-13.5,2.83s3.335-7.645,2.01-15.131c-.292-1.653-.382-3.161-.634-3.873-.337-.952.551-1.716,1.328-2.183.168-.1.33-.181.472-.253.317-.155.544-.24.544-.24s.719-.091,2.934-.24a2.1,2.1,0,0,1,1.633.8c2.008,2.137,3.213,7.883,3.173,9.12a1.649,1.649,0,0,1-1.587,1.612C494.483,389.248,497.936,393.9,497.936,393.9Z",
    transform: "translate(-478.298 -358.301)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6243",
    "data-name": "Path 6243",
    d: "M497.711,392.4a16.29,16.29,0,0,1-3.628-.389,6.2,6.2,0,0,0,3.8,1.431Z",
    transform: "translate(-481.695 -364.361)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6244",
    "data-name": "Path 6244",
    d: "M486.067,379.511a73.607,73.607,0,0,1,.426,10.763c-.091,2.566-2.053,7.7-2.053,7.7a21.936,21.936,0,0,0,6.641.1s-2.159.135-1.768-3.428-1.446-13.678-2.633-15.566S486.067,379.511,486.067,379.511Z",
    transform: "translate(-478.298 -359.546)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6245",
    "data-name": "Path 6245",
    d: "M491.235,395.555c.521-1.295,3.685.036,4.407.559a.261.261,0,0,1-.06.449c.05.036.1.069.152.107.243.185,0,.6-.242.415-.016-.012-.034-.021-.05-.034a.264.264,0,0,1-.382.068c-.068-.053-.143-.1-.212-.146-.026.134-.181.085-.326.024-.56-.234-.913-.455-1.442-.639a2.856,2.856,0,0,1-1.561-.009A.53.53,0,0,1,491.235,395.555Z",
    transform: "translate(-480.658 -365.417)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6246",
    "data-name": "Path 6246",
    d: "M484.948,376.73a16.223,16.223,0,0,1-1.84,5.13,52.921,52.921,0,0,1-4.884,7.563c-1.457,1.976-3.926-.41-3.1-1.777s4.5-7.561,4.5-7.561,2.157-3.685,4.016-4.417a1.486,1.486,0,0,1,.634-.117,1.163,1.163,0,0,1,.363.065C484.89,375.713,485.007,376.088,484.948,376.73Z",
    transform: "translate(-474.958 -358.563)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6247",
    "data-name": "Path 6247",
    d: "M475.211,395.557c.009-.424.6-.723,2.307-.825,1.332-.079,8.583.167,8.583.167l.269,1.558s-7.438,1.06-8.836.743S475.193,396.5,475.211,395.557Z",
    transform: "translate(-475.047 -365.315)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6248",
    "data-name": "Path 6248",
    d: "M494.108,375.607a2.1,2.1,0,0,0-1.633-.8c-2.215.149-2.934.24-2.934.24s-.227.084-.544.24a1.477,1.477,0,0,0-.634.117c.052.045.11.091.162.136.382.305.764.615,1.146.927.259.214.525.427.784.641a8.7,8.7,0,0,0,1.847,1.425c.978.408,1.554-.544,1.716-1.366A5.122,5.122,0,0,0,494.108,375.607Z",
    transform: "translate(-479.68 -358.301)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6249",
    "data-name": "Path 6249",
    d: "M485.689,382.594s-.181,1.638-4.662,7.859c.7.067,3.11.2,3.11.2s-4.741.6-4.13-.192C481.14,388.984,485.689,382.594,485.689,382.594Z",
    transform: "translate(-476.717 -361.045)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6250",
    "data-name": "Path 6250",
    d: "M493.53,368.916a24.441,24.441,0,0,0-.016,4.2c-.65,1.98-3.752.035-3.752.035.045-.413.062-.914.065-1.414,0-1.023-.058-2.044-.08-2.34a.348.348,0,0,0,0-.047.241.241,0,0,0,0-.034Z",
    transform: "translate(-480.166 -356.226)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6251",
    "data-name": "Path 6251",
    d: "M493.481,369.274c-.023.161-.043.312-.056.452a6.807,6.807,0,0,0-.052,1.124c0,.365.014.931.012,1.315-.813.7-2.994-.723-3.632-1.682-.03-1.042-.18-2.319-.18-2.319Z",
    transform: "translate(-480.106 -355.961)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6252",
    "data-name": "Path 6252",
    d: "M493.251,375.317c-.525,1.246-2.939.367-3.674-.062-.361-.211-.636.163-.277.372,1.178.687,3.978,1.51,4.307-.27C493.642,375.167,493.367,375.04,493.251,375.317Z",
    transform: "translate(-479.951 -358.425)",
    fill: "#f0c960"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(35.434 64.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6253",
    "data-name": "Path 6253",
    d: "M530.735,449.7c-.591.239-1.071,2.246-1.071,2.246h5.49a13.325,13.325,0,0,1-2.527-1.332C531.361,449.786,531.2,449.512,530.735,449.7Z",
    transform: "translate(-529.664 -449.643)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 5.49,
    height: 0.428,
    transform: "translate(0 2.302)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(20.27 64.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6254",
    "data-name": "Path 6254",
    d: "M507.324,449.7c-.591.239-1.071,2.246-1.071,2.246h5.49a13.326,13.326,0,0,1-2.527-1.332C507.95,449.786,507.787,449.512,507.324,449.7Z",
    transform: "translate(-506.252 -449.643)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 5.49,
    height: 0.428,
    transform: "translate(0 2.302)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6255",
    "data-name": "Path 6255",
    d: "M487.813,356.914s.149,5.5,1.4,7.409,3.649,3.441,4.422,3.255c2.047-.489,3.531-5.713,3.256-9.339C496.55,353.729,492.244,351.944,487.813,356.914Z",
    transform: "translate(-479.486 -350.946)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(11.057 7.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6256",
    "data-name": "Path 6256",
    d: "M492.4,363.127c.06-.553.372-.935.716-.857.363.084.632.645.58,1.262s-.413,1.023-.783.876A1.261,1.261,0,0,1,492.4,363.127Z",
    transform: "translate(-492.155 -361.813)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6257",
    "data-name": "Path 6257",
    d: "M498.268,362.87c-.01-.558.2-1.015.48-1.025s.545.469.557,1.071-.225,1.065-.519,1.029S498.278,363.43,498.268,362.87Z",
    transform: "translate(-494.227 -361.667)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6258",
    "data-name": "Path 6258",
    d: "M499.489,362.387a2.351,2.351,0,0,0-1.563-.494.589.589,0,0,1,.657-.313C499.075,361.659,499.489,362.387,499.489,362.387Z",
    transform: "translate(-494.106 -361.57)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6259",
    "data-name": "Path 6259",
    d: "M492.029,362.817a2.358,2.358,0,0,1,1.668-.478.841.841,0,0,0-.872-.317C492.267,362.122,492.029,362.817,492.029,362.817Z",
    transform: "translate(-492.029 -361.723)",
    fill: "#503d39"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6260",
    "data-name": "Path 6260",
    d: "M496.57,365.236a3.583,3.583,0,0,1,.891,1.308c.023.066.045.13.065.2a.442.442,0,0,1-.056.381.669.669,0,0,1-.489.22,1.734,1.734,0,0,1-.809-.137c.258-.085.512-.157.729-.234.1-.038.211-.1.19-.111s-.007.073-.022.012-.039-.106-.062-.161A6.233,6.233,0,0,1,496.57,365.236Z",
    transform: "translate(-482.431 -354.93)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(12.899 13.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6261",
    "data-name": "Path 6261",
    d: "M494.872,369.533s1.268.743,2.084.343c0,0-.354,1.594-.838,1.549C495.509,371.368,494.959,370.374,494.872,369.533Z",
    transform: "translate(-494.872 -369.533)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6262",
    "data-name": "Path 6262",
    d: "M492.935,360c.233.074.133.48-.1.528a7.165,7.165,0,0,0-2.617.621C490.12,361.19,491.874,359.667,492.935,360Z",
    transform: "translate(-480.331 -353.069)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6263",
    "data-name": "Path 6263",
    d: "M497.279,359.752c-.225.1-.084.49.157.515a7.15,7.15,0,0,1,2.665.358C500.2,360.653,498.3,359.312,497.279,359.752Z",
    transform: "translate(-482.781 -352.966)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6264",
    "data-name": "Path 6264",
    d: "M487,354.828a9.9,9.9,0,0,1,.3,3.952,2.439,2.439,0,0,0-1.518-.225s-3.43-3.143-2.2-5.868c0-.006.006-.006.005-.012a5.472,5.472,0,0,1,2.053-2.445,6.844,6.844,0,0,1,5.267-.5c5.02-1.8,7.729,2.935,6.664,4.628C496.107,356.677,487,354.828,487,354.828Z",
    transform: "translate(-477.902 -349.324)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(7.365 8.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6265",
    "data-name": "Path 6265",
    d: "M488.567,363.747c-.432-.417-1.948-1.339-2.2-.365-.317,1.225,1.432,4,2.4,2.417A1.909,1.909,0,0,0,488.567,363.747Z",
    transform: "translate(-486.328 -362.951)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6266",
    "data-name": "Path 6266",
    d: "M488.581,364.575s-1.191-.906-1.191-.246a1.619,1.619,0,0,0,1,1.576,1.49,1.49,0,0,1-.28-.957C488.169,364.438,488.581,364.575,488.581,364.575Z",
    transform: "translate(-486.702 -363.352)",
    fill: "#f29866"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(41.529 50.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(0 9.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 18.394,
    height: 0.971,
    transform: "translate(8.467 1.895)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6267",
    "data-name": "Path 6267",
    d: "M512.076,397.533h-8.467v-1.088l8.467.117Z",
    transform: "translate(-503.609 -394.666)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6268",
    "data-name": "Path 6268",
    d: "M503.609,395.478l21.027-1.779,5.835,1.9H512.076Z",
    transform: "translate(-503.609 -393.699)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(8.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6269",
    "data-name": "Path 6269",
    d: "M534.315,390.183H515.994l2.412-11.281a.69.69,0,0,1,.663-.563h16.5a1.07,1.07,0,0,1,.994,1.326Z",
    transform: "translate(-515.994 -378.34)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6270",
    "data-name": "Path 6270",
    d: "M535,390.183H516.681l2.412-11.281a.69.69,0,0,1,.663-.563H536.6a.779.779,0,0,1,.724.966Z",
    transform: "translate(-516.236 -378.34)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6271",
    "data-name": "Path 6271",
    d: "M538.914,390.183H527.785L534.9,378.34h5.616a.779.779,0,0,1,.724.966Z",
    transform: "translate(-520.148 -378.34)",
    fill: "#8b8b8b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(0 63.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6272",
    "data-name": "Path 6272",
    d: "M441.651,400.534H514.43l1.683-2.9H439.968Z",
    transform: "translate(-439.66 -397.638)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6273",
    "data-name": "Path 6273",
    d: "M553.783,435.51h1.5l-3.531-33.4h-3.187Z",
    transform: "translate(-477.918 -399.213)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6274",
    "data-name": "Path 6274",
    d: "M549.252,406.49l3.318,3.318-.814-7.7h-3.187Z",
    transform: "translate(-477.918 -399.213)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6275",
    "data-name": "Path 6275",
    d: "M541.8,435.51h1.5l-3.531-33.4h-3.188Z",
    transform: "translate(-473.697 -399.213)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6276",
    "data-name": "Path 6276",
    d: "M441,435.51h-1.5l3.532-33.4h3.187Z",
    transform: "translate(-439.492 -399.213)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6277",
    "data-name": "Path 6277",
    d: "M447.3,405.614l-3.172,1.527.532-5.033h3.187Z",
    transform: "translate(-441.123 -399.213)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6278",
    "data-name": "Path 6278",
    d: "M452.121,435.51h-1.5l3.532-33.4h3.188Z",
    transform: "translate(-443.411 -399.213)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6279",
    "data-name": "Path 6279",
    d: "M537.188,405.959l3.253,2.452-.667-6.3h-3.188Z",
    transform: "translate(-473.697 -399.213)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6280",
    "data-name": "Path 6280",
    d: "M458.552,404.77l-3.3,2.371.532-5.033h3.188Z",
    transform: "translate(-445.043 -399.213)",
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(93.083 34.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    transform: "translate(3.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(34.641 21.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6284",
    "data-name": "Path 6284",
    d: "M641.686,386.883l.05,44.185,19.418.073-.05-44.185Z",
    transform: "translate(-641.686 -386.883)",
    fill: "#f8f0e5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(0 43.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6285",
    "data-name": "Path 6285",
    d: "M588.2,420.615l.05,22.336,19.417.073-.049-22.336Z",
    transform: "translate(-588.204 -420.615)",
    fill: "#f8f0e5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(66.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6286",
    "data-name": "Path 6286",
    d: "M690.583,353.151l.05,66.034,19.418.073L710,353.224Z",
    transform: "translate(-690.583 -353.151)",
    fill: "#f8f0e5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(34.641 21.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6287",
    "data-name": "Path 6287",
    d: "M636.685,386.883l.05,44.185,19.418.073-.049-44.185Z",
    transform: "translate(-636.685 -386.883)",
    fill: "#e5e1d6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(34.641 21.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6288",
    "data-name": "Path 6288",
    d: "M636.685,386.883l.05,44.185,11.738.073-8.549-44.185Z",
    transform: "translate(-636.685 -386.883)",
    fill: "#d3d3d3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(0 43.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6289",
    "data-name": "Path 6289",
    d: "M583.2,420.615l.05,22.336,19.418.073-.05-22.336Z",
    transform: "translate(-583.203 -420.615)",
    fill: "#e5e1d6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(0 43.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6290",
    "data-name": "Path 6290",
    d: "M583.2,420.615l.05,22.336,11.154.073-7.964-22.336Z",
    transform: "translate(-583.203 -420.615)",
    fill: "#d3d3d3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(66.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6291",
    "data-name": "Path 6291",
    d: "M685.583,353.151l.05,66.034,19.418.073L705,353.224Z",
    transform: "translate(-685.583 -353.151)",
    fill: "#e5e1d6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(66.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6292",
    "data-name": "Path 6292",
    d: "M685.583,353.151l.05,66.034,12.923.073L690.9,353.224Z",
    transform: "translate(-685.583 -353.151)",
    fill: "#d3d3d3"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    transform: "translate(103.899 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6293",
    "data-name": "Path 6293",
    d: "M616.27,362.027l-.641-5.047s15.007-2.57,15.58-2.549c1.836.065,4.06,5.174.29,5.948C626.521,361.4,616.27,362.027,616.27,362.027Z",
    transform: "translate(-605.442 -319.355)",
    fill: "#9ed1de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6294",
    "data-name": "Path 6294",
    d: "M644.25,340.262c-.12.316-.24.633-.372.954-.253.632-.525,1.262-.808,1.878-2.025,4.4-4.755,8.314-6.629,8.474-.307.03-4.322-.486-4.815-1.606-.342-.764,2.3-4.694,3.425-6.68.549-.968,1.468-2.409,2.551-3.95.44-.632.907-1.273,1.394-1.908,2.126-2.812,4.492-5.417,5.821-5.577C645.786,331.734,645.331,337.357,644.25,340.262Z",
    transform: "translate(-611.066 -311.399)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6295",
    "data-name": "Path 6295",
    d: "M645.683,341.625c-1.631,4.249-5.908,9.718-7.532,10.635-1.84,1.039-3.842.468-6.978-1.755,4.224.586,4.938.852,7.964-3.661a12.363,12.363,0,0,0,1.606-4.465c.161-.82.3-1.667.429-2.5a17.137,17.137,0,0,1,1.465-5.494,6.978,6.978,0,0,1,1.134-1.536c.137,0,.273.007.4.014a2.468,2.468,0,0,1,.38.052C644.809,334.16,645.921,341,645.683,341.625Z",
    transform: "translate(-610.918 -311.753)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6296",
    "data-name": "Path 6296",
    d: "M646.112,345.645c.162-.82.194-1.108.323-1.937.581.411,1.192.785,1.821,1.167a4.893,4.893,0,0,1,.737.519c.006,0,.006.007.012.008a2.73,2.73,0,0,1,.939,1.507C650.066,347.379,646.812,346.044,646.112,345.645Z",
    transform: "translate(-616.18 -315.578)",
    fill: "#5771ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6297",
    "data-name": "Path 6297",
    d: "M644.8,342.563c-.13.828-.161,1.117-.323,1.937a10.426,10.426,0,0,1-3.011-2.679c.44-.632.523-.729,1.009-1.363.279.285.525.569.718.765A12.029,12.029,0,0,0,644.8,342.563Z",
    transform: "translate(-614.543 -314.433)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(19.74 76.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6298",
    "data-name": "Path 6298",
    d: "M633.783,418c.768-.05,2.292,1.608,2.292,1.608l-5.687,3.11s1.042-1.259,2.032-2.559C633.551,418.669,633.183,418.036,633.783,418Z",
    transform: "translate(-630.381 -417.995)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 6.482,
    height: 0.58,
    transform: "translate(0 4.689) rotate(-28.68)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(0 72.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6299",
    "data-name": "Path 6299",
    d: "M606.041,413.956c.286.714-.813,2.679-.813,2.679L600.5,412.2s1.521.6,3.065,1.132C605.33,413.945,605.816,413.4,606.041,413.956Z",
    transform: "translate(-600.112 -412.201)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 6.482,
    height: 0.58,
    transform: "matrix(0.729, 0.684, -0.684, 0.729, 0.397, 0.005)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6300",
    "data-name": "Path 6300",
    d: "M616.384,376.322c-1.689,1.839-9.147,21.957-9.147,21.957l1.2,1.448,13.4-18.569c2.771-.911,11.562-.569,11.955-1.189,1.216-1.919,4.4-7.82,4.4-7.82-.595.025-1.617-3.123-1.617-3.123C627.562,369.026,618.373,374.155,616.384,376.322Z",
    transform: "translate(-602.485 -324.497)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6301",
    "data-name": "Path 6301",
    d: "M622.282,382.858l-13.4,18.569-.391-.47s11.83-19.358,12.584-21.263c1.372-3.466,12.06-5.845,12.06-5.845L626.8,383A29.136,29.136,0,0,1,622.282,382.858Z",
    transform: "translate(-602.926 -326.196)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6302",
    "data-name": "Path 6302",
    d: "M630.158,378.67c-.747,2.019,2.569,22.987,2.569,22.987l2.211-.523,1.255-19.437s15.267-.494,16.563-2.539c1.216-1.919,1.926-7.522,1.926-7.522-.595.026-6.233-2.575-6.233-2.575C640.182,371.005,630.816,376.892,630.158,378.67Z",
    transform: "translate(-610.521 -324.51)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6303",
    "data-name": "Path 6303",
    d: "M651.355,323.967c.074.188.142.365.193.529a9.055,9.055,0,0,1,.319,1.325,10.282,10.282,0,0,1,.148,1.222,11.417,11.417,0,0,1-.045,2.11c3.457,1.705,7.2-.643,7.2-.643a11.36,11.36,0,0,1-.4-1.665,25.61,25.61,0,0,1-.313-2.781.211.211,0,0,1-.006-.057.233.233,0,0,1-.006-.04h-7.1Z",
    transform: "translate(-618.027 -308.623)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6304",
    "data-name": "Path 6304",
    d: "M656.919,372.931s.738,6.627-2.939,7.714c-4.544,1.341-15.434,1.527-15.434,1.527l-1.255,19.437s.35-19.129-.562-20.262c0,0,.788.648,1.031.324s-.486-1.9-.486-1.9,9.961,1.328,13.11.235,1.976-5.061,1.328-5.627-7.53-1.66-9.149-3.967Z",
    transform: "translate(-612.875 -324.984)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6305",
    "data-name": "Path 6305",
    d: "M651.355,323.967c.074.188.142.365.193.529a5.443,5.443,0,0,1,.319,1.325,10.282,10.282,0,0,1,.148,1.222,8.492,8.492,0,0,0,4.844.722,4.588,4.588,0,0,0,1.916-.921,25.578,25.578,0,0,1-.313-2.781.211.211,0,0,1-.006-.057.233.233,0,0,1-.006-.04h-7.1Z",
    transform: "translate(-618.027 -308.623)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6306",
    "data-name": "Path 6306",
    d: "M656.741,329.58a17.083,17.083,0,0,1,4.917,2.183s-1.667,21.791-1.24,27.666c0,0-13.906-1.244-16.558-4.276a109.111,109.111,0,0,0,1.3-13.254c0-5.117,1.769-9.76,3.853-11.087C649.007,330.812,652.192,332.9,656.741,329.58Z",
    transform: "translate(-615.387 -310.601)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6307",
    "data-name": "Path 6307",
    d: "M663.842,345.732s-.3,5.134-.719,9.7c-.234,2.569-1.7.407-13.794,1.306,2.986-1.282,9.933-6.5,9.585-8.648a17.412,17.412,0,0,1,2.343-12.416S662.989,343.742,663.842,345.732Z",
    transform: "translate(-617.314 -312.747)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6308",
    "data-name": "Path 6308",
    d: "M659.4,314.929s-.567,3.775-1.908,4.52-6.047.808-7.046-.389-.811-11.065-.436-11.834,6.882-3.625,9.091-.479S659.4,314.929,659.4,314.929Z",
    transform: "translate(-617.446 -302.048)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6309",
    "data-name": "Path 6309",
    d: "M661.287,304.566a1.359,1.359,0,0,0-1.147.227,4.091,4.091,0,0,1,.6,2.863c-.881,4.612-3.22,5.414-3.66,5.292-2.047-.57-2.222-4.379-1.088-7.293,0,0-.311-.033-.771-.078a18.161,18.161,0,0,0-2.779-.143.1.1,0,0,0-.045.007c-.168.006-.343.019-.512.039a1.178,1.178,0,0,0-.129.019,7.963,7.963,0,0,0-1.049.181c-.861.2-3.459.472-4.333-.052a1.844,1.844,0,0,1-.266-.207,2.136,2.136,0,0,1-.764-.719,3.85,3.85,0,0,1-.284-3.128.326.326,0,0,1,.628.169,3.964,3.964,0,0,0-.117,1.4,3.375,3.375,0,0,1,.3-.927,1.971,1.971,0,0,1,.337-.512c1.671-1.807,4.184-1.535,7.591-1.12a10.25,10.25,0,0,1,5.693,3.387,3.143,3.143,0,0,0-.091-1.937c-.142-.389.486-.556.622-.168a3.686,3.686,0,0,1,.1,2.176,2.253,2.253,0,0,1,1.334-.1C661.87,304.022,661.7,304.644,661.287,304.566Z",
    transform: "translate(-615.741 -300.278)",
    fill: "#872f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6310",
    "data-name": "Path 6310",
    d: "M658.465,309.813a6.5,6.5,0,0,0-3.02-.309,1.745,1.745,0,0,0-.008,1.311,13.009,13.009,0,0,0,2.913-.2A1.75,1.75,0,0,0,658.465,309.813Z",
    transform: "translate(-619.422 -303.502)",
    fill: "#71201c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6311",
    "data-name": "Path 6311",
    d: "M648.59,310.327a6.068,6.068,0,0,1,2.79-.827,1.749,1.749,0,0,1,.181,1.282,11.992,11.992,0,0,1-2.757.306A1.766,1.766,0,0,1,648.59,310.327Z",
    transform: "translate(-617.05 -303.519)",
    fill: "#71201c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6312",
    "data-name": "Path 6312",
    d: "M657.024,314.374c-.094.549-.429.91-.769.812-.357-.106-.59-.683-.5-1.3s.475-1,.836-.825A1.257,1.257,0,0,1,657.024,314.374Z",
    transform: "translate(-619.571 -304.768)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6313",
    "data-name": "Path 6313",
    d: "M651.3,314.314c-.025.558-.262,1-.543.994s-.516-.5-.49-1.1.291-1.049.582-1S651.322,313.755,651.3,314.314Z",
    transform: "translate(-617.642 -304.832)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(33.42 10.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6314",
    "data-name": "Path 6314",
    d: "M652.589,316.37s-.9,1.97-.7,2.491,1.674.228,1.674.228Z",
    transform: "translate(-651.627 -316.37)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6315",
    "data-name": "Path 6315",
    d: "M652.46,316.37q-.1.559-.236,1.084c-.084.351-.185.7-.232,1.028-.026.165-.025.311.013.328a.685.685,0,0,0,.36.159,9.947,9.947,0,0,0,1.074.12,2.6,2.6,0,0,1-1.115.257.961.961,0,0,1-.651-.217.592.592,0,0,1-.172-.389,1.686,1.686,0,0,1,.01-.327A4.716,4.716,0,0,1,652.46,316.37Z",
    transform: "translate(-651.498 -316.37)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(41.168 10.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6316",
    "data-name": "Path 6316",
    d: "M664.019,316.681c.449-.461,2.351-1.008,2.588-.248.381,1.216-1.088,3.562-2.841,2.61C663.127,318.7,663.63,317.08,664.019,316.681Z",
    transform: "translate(-663.461 -316.055)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6317",
    "data-name": "Path 6317",
    d: "M664.84,317.886s1.393-.913,1.525-.5c.257.808-.89,1.474-1.219,1.591,0,0,.641-.7.475-1S664.84,317.886,664.84,317.886Z",
    transform: "translate(-663.947 -316.486)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6318",
    "data-name": "Path 6318",
    d: "M655.995,306.235s-.311-.033-.771-.078c-.784-.065-1.988-.155-2.779-.143a.1.1,0,0,0-.045.007,3.408,3.408,0,0,0-.492.032.024.024,0,0,0-.019.007,1.178,1.178,0,0,0-.129.019,7.961,7.961,0,0,0-1.049.181,9.547,9.547,0,0,1-4.03.166,4.121,4.121,0,0,1-1.334-1.145,3.851,3.851,0,0,1-.284-3.128.326.326,0,0,1,.628.169,3.964,3.964,0,0,0-.117,1.4,3.375,3.375,0,0,1,.3-.927c-.525,2.487,1.366,3.4,2.489,2.987C652.886,304.113,654.278,304.881,655.995,306.235Z",
    transform: "translate(-615.741 -300.859)",
    fill: "#71201c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(33.541 14.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6319",
    "data-name": "Path 6319",
    d: "M651.685,323.181a1.539,1.539,0,0,0,2.448-.481Z",
    transform: "translate(-651.685 -322.7)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6320",
    "data-name": "Path 6320",
    d: "M651.685,323.181a3.233,3.233,0,0,0,1.321.172,1.335,1.335,0,0,0,.558-.22,6.337,6.337,0,0,0,.569-.433,1.347,1.347,0,0,1-.317.717,1.2,1.2,0,0,1-.731.415A1.422,1.422,0,0,1,651.685,323.181Z",
    transform: "translate(-651.685 -322.7)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(34.663 16.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6321",
    "data-name": "Path 6321",
    d: "M653.417,325.4a5.134,5.134,0,0,1,.951-.223Z",
    transform: "translate(-653.417 -325.141)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6322",
    "data-name": "Path 6322",
    d: "M653.417,325.379a1.308,1.308,0,0,1,.45-.214.894.894,0,0,1,.5-.009c-.082.027-.153.065-.229.091s-.154.048-.23.074A1.708,1.708,0,0,1,653.417,325.379Z",
    transform: "translate(-653.417 -325.123)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(25.148 44.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6323",
    "data-name": "Path 6323",
    d: "M643.037,370.688a10.1,10.1,0,0,1,2.822.413c.351.106.585.22.683.537a.333.333,0,0,1,.019.492,2.173,2.173,0,0,1-2.639.259c-1.029-.433-1.459.082-2.264.534a.834.834,0,0,1-.786.15.322.322,0,0,1-.176-.25C640.471,371.754,642.232,370.7,643.037,370.688Z",
    transform: "translate(-639.413 -369.538)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6324",
    "data-name": "Path 6324",
    d: "M641.715,370.831a12.251,12.251,0,0,1,2.8.075c.35.052,1.032-.42,1.132-.178.128.081.265.941.106,1.072a3.714,3.714,0,0,1-3.145.294c-1.026-.25-1.447.194-2.24.622a1.04,1.04,0,0,1-.777.188.237.237,0,0,1-.177-.181C639.182,371.9,640.916,370.912,641.715,370.831Z",
    transform: "translate(-638.962 -369.528)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6325",
    "data-name": "Path 6325",
    d: "M641.044,370.456a12.293,12.293,0,0,1,2.805.075c.35.052.583.121.684.363a.227.227,0,0,1,.025.387,2.665,2.665,0,0,1-2.615.439c-1.025-.25-1.446.194-2.24.622a1.044,1.044,0,0,1-.778.188.236.236,0,0,1-.177-.181C638.512,371.525,640.245,370.537,641.044,370.456Z",
    transform: "translate(-638.726 -369.44)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6326",
    "data-name": "Path 6326",
    d: "M639.292,370.933h0a2.6,2.6,0,0,1,1.016-1.1,3.564,3.564,0,0,1,2.262-.771,31.329,31.329,0,0,0,3.752-.148l-.054,1.374c-.031.867-2.914.646-3.811.428-1.025-.25-1.446.194-2.24.622a1.041,1.041,0,0,1-.778.188.236.236,0,0,1-.177-.181A.673.673,0,0,1,639.292,370.933Z",
    transform: "translate(-638.908 -368.913)",
    fill: "#f5b379"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6327",
    "data-name": "Path 6327",
    d: "M672.917,352.016c-.039.214-.084.415-.13.622-.013.045-.019.091-.032.129a1.268,1.268,0,0,1-.078.22,2.123,2.123,0,0,1-1.114,1.27,4.593,4.593,0,0,1-3.99-.583,5.86,5.86,0,0,1-.576-.35c-1.7-1.153-.719-2.526-.887-3.018a9.061,9.061,0,0,1-.221-1.328c-.382-3.1-.81-10.065-.81-10.065a12.131,12.131,0,0,1,3.356-6.625.687.687,0,0,1,.142.058C672.541,333.907,674.439,344.464,672.917,352.016Z",
    transform: "translate(-622.862 -311.555)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6328",
    "data-name": "Path 6328",
    d: "M665.964,365.074a2.618,2.618,0,0,1-.506.276c-4.368,1.808-13.281,2.591-15.667,2.774l-.6.039-1.078-3.092s6.945-2.832,11.541-4.493a24.742,24.742,0,0,1,3.759-1.178,3.426,3.426,0,0,1,1.6.181,3.35,3.35,0,0,1,1.773,1.819C666.886,361.6,666.484,364.706,665.964,365.074Z",
    transform: "translate(-616.884 -321.098)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6329",
    "data-name": "Path 6329",
    d: "M671.7,350.445a10.921,10.921,0,0,1-6.095.408v-1.178a17.617,17.617,0,0,0,5.927-.667C671.6,349.486,671.657,349.965,671.7,350.445Z",
    transform: "translate(-623.046 -317.445)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6330",
    "data-name": "Path 6330",
    d: "M667.953,343.841a12.511,12.511,0,0,1-1.833.745,15.3,15.3,0,0,1-.176,4.132c-.136.719-.515,4.376-3.268,5.816a41.841,41.841,0,0,1-12.9,4.116c2.389.13,12.525-.981,16.775-3.089C668.126,354.781,668.16,346.613,667.953,343.841Zm-2-.692a8.033,8.033,0,0,0,1.846-.855c-.6-4.812-2.235-8.977-4.612-9.916a.184.184,0,0,0-.013.058.534.534,0,0,0-.071.531A55.832,55.832,0,0,1,665.951,343.148Z",
    transform: "translate(-617.471 -311.586)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6331",
    "data-name": "Path 6331",
    d: "M676.751,349.234a12.516,12.516,0,0,1-1.833.745c-.039-.479-.091-.959-.168-1.438a8.032,8.032,0,0,0,1.846-.855l.143,1.444C676.745,349.163,676.745,349.2,676.751,349.234Z",
    transform: "translate(-626.269 -316.979)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(6.822 36.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(2.271 9.948)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 18.394,
    height: 0.972,
    transform: "translate(0 1.895)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6332",
    "data-name": "Path 6332",
    d: "M642.338,375.743h8.468v-1.088l-8.468.116Z",
    transform: "translate(-623.944 -372.876)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6333",
    "data-name": "Path 6333",
    d: "M640.8,373.687l-21.027-1.779-5.835,1.9h18.394Z",
    transform: "translate(-613.939 -371.908)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6334",
    "data-name": "Path 6334",
    d: "M613.5,368.392h18.321l-2.412-11.28a.691.691,0,0,0-.663-.564h-16.5a1.07,1.07,0,0,0-.995,1.327Z",
    transform: "translate(-610.713 -356.549)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6335",
    "data-name": "Path 6335",
    d: "M612.777,368.392H631.1l-2.412-11.28a.691.691,0,0,0-.663-.564H611.176a.78.78,0,0,0-.724.966Z",
    transform: "translate(-610.433 -356.549)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6336",
    "data-name": "Path 6336",
    d: "M612.777,368.392h11.129l-7.114-11.843h-5.616a.78.78,0,0,0-.724.966Z",
    transform: "translate(-610.433 -356.549)",
    fill: "#8b8b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953",
    transform: "translate(103.899 25.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6337",
    "data-name": "Path 6337",
    d: "M608.682,321.352h1.358a4.612,4.612,0,0,1-1.957,2.027,7.471,7.471,0,0,1-3.684.841,8.537,8.537,0,0,1-3.632-.711,4.782,4.782,0,0,1-2.275-2.1,6.262,6.262,0,0,1-.746-3.017,6.829,6.829,0,0,1,.848-3.336,5.573,5.573,0,0,1,2.32-2.319,7.119,7.119,0,0,1,3.364-.774,6.3,6.3,0,0,1,2.855.624,4.422,4.422,0,0,1,1.908,1.775,4.968,4.968,0,0,1,.66,2.514,4.727,4.727,0,0,1-1,2.938,3.869,3.869,0,0,1-3.218,1.657,1.41,1.41,0,0,1-.8-.185.9.9,0,0,1-.357-.542,2.422,2.422,0,0,1-1.734.727,2.326,2.326,0,0,1-1.755-.73,2.688,2.688,0,0,1-.7-1.941,4.757,4.757,0,0,1,.841-2.734,3.052,3.052,0,0,1,2.612-1.5,1.837,1.837,0,0,1,1.676.867l.159-.708h1.682l-.962,4.57a3.7,3.7,0,0,0-.089.561.344.344,0,0,0,.073.239.229.229,0,0,0,.175.079,1.454,1.454,0,0,0,.791-.369,3.527,3.527,0,0,0,1.051-1.3,3.783,3.783,0,0,0,.4-1.689,3.437,3.437,0,0,0-1.134-2.623,4.473,4.473,0,0,0-3.167-1.054,5.7,5.7,0,0,0-2.928.7,4.477,4.477,0,0,0-1.81,1.982,6.121,6.121,0,0,0-.608,2.661,4.568,4.568,0,0,0,.679,2.446,3.944,3.944,0,0,0,1.906,1.609,8.168,8.168,0,0,0,5.426.084A4.066,4.066,0,0,0,608.682,321.352Zm-6.888-2.619a1.8,1.8,0,0,0,.328,1.192,1.03,1.03,0,0,0,.812.382,1.378,1.378,0,0,0,.682-.178,1.684,1.684,0,0,0,.478-.4,3.3,3.3,0,0,0,.583-1.134,4.472,4.472,0,0,0,.246-1.389,1.635,1.635,0,0,0-.335-1.106,1.071,1.071,0,0,0-.845-.386,1.479,1.479,0,0,0-1.013.424,2.605,2.605,0,0,0-.7,1.207A4.895,4.895,0,0,0,601.794,318.733Z",
    transform: "translate(-597.746 -311.966)",
    fill: "#701FFF"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6721",
    "data-name": "Path 6721",
    d: "M1.3,0h3.1V-11.7H1.3Zm5.22,0h3.636c3.384,0,5.832-1.764,5.832-5.9s-2.448-5.8-6.012-5.8H6.516Zm3.1-2.484V-9.216h.18c1.692,0,3.024.576,3.024,3.312s-1.332,3.42-3.024,3.42ZM17.6,0h7.74V-2.592H20.7V-4.68h3.816V-7.272H20.7V-9.108h4.464V-11.7H17.6ZM30.168-5.688c.288-1.116.576-2.52.828-3.708h.072c.288,1.17.576,2.592.864,3.708l.2.81H29.97ZM25.668,0h3.168l.576-2.484h3.276L33.264,0H36.54L32.976-11.7H29.232ZM37.98,0h3.1V-9.108h3.1V-11.7H34.884v2.592h3.1Zm7.452,0h7.74V-2.592H48.528V-4.68h3.816V-7.272H48.528V-9.108h4.464V-11.7h-7.56Z",
    transform: "translate(291.604 685.25)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6722",
    "data-name": "Path 6722",
    d: "M1.3,0h3.1V-3.708h1.26c2.448,0,4.68-1.242,4.68-4.1,0-2.952-2.2-3.888-4.752-3.888H1.3Zm3.1-6.156v-3.1H5.436c1.188,0,1.872.4,1.872,1.44s-.576,1.656-1.8,1.656ZM11.772,0H19.3V-2.592H14.868V-11.7h-3.1ZM23.688-5.688c.288-1.116.576-2.52.828-3.708h.072c.288,1.17.576,2.592.864,3.708l.2.81H23.49ZM19.188,0h3.168l.576-2.484h3.276L26.784,0H30.06L26.5-11.7H22.752Zm11.52,0H33.66V-3.384a43.779,43.779,0,0,0-.4-4.464h.072c.36.9.72,1.836,1.116,2.628L37.044,0h3.168V-11.7H37.26v3.384a42.012,42.012,0,0,0,.4,4.464h-.072c-.36-.9-.72-1.836-1.116-2.628L33.876-11.7H30.708Z",
    transform: "translate(439.662 731.25)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6723",
    "data-name": "Path 6723",
    d: "M1.3,0h7.74V-2.592H4.392V-4.68H8.208V-7.272H4.392V-9.108H8.856V-11.7H1.3ZM9.72,0h3.312L13.9-2.088c.252-.612.5-1.224.756-1.944h.072c.288.72.54,1.332.828,1.944L16.488,0h3.456L16.776-5.868,19.764-11.7H16.452l-.684,1.908c-.216.54-.468,1.188-.72,1.944h-.072c-.324-.756-.576-1.4-.828-1.944L13.356-11.7H9.9l2.988,5.688ZM20.952,0h7.74V-2.592H24.048V-4.68h3.816V-7.272H24.048V-9.108h4.464V-11.7h-7.56ZM35.568.216A4.948,4.948,0,0,0,39.42-1.512L37.8-3.348a2.838,2.838,0,0,1-2.124.9c-1.512,0-2.52-1.224-2.52-3.42,0-2.124,1.188-3.384,2.556-3.384a2.749,2.749,0,0,1,1.944.756l1.62-1.872a5.019,5.019,0,0,0-3.636-1.548c-2.952,0-5.652,2.232-5.652,6.156C29.988-1.764,32.58.216,35.568.216ZM45,.216c3.276,0,4.788-1.872,4.788-5.868V-11.7H46.8v6.408c0,2.088-.576,2.844-1.8,2.844S43.236-3.2,43.236-5.292V-11.7h-3.1v6.048C40.14-1.656,41.724.216,45,.216ZM54.072,0h3.1V-9.108h3.1V-11.7H50.976v2.592h3.1Zm7.452,0h7.74V-2.592H64.62V-4.68h3.816V-7.272H64.62V-9.108h4.464V-11.7h-7.56Z",
    transform: "translate(591.161 722.25)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6725",
    "data-name": "Path 6725",
    d: "M1.3,0H4.068V-3.456c0-1.188-.252-3.348-.4-4.536h.072L4.68-4.824,6.12-.954H7.776l1.44-3.87.972-3.168h.072c-.144,1.188-.4,3.348-.4,4.536V0h2.808V-11.7H9.36L7.668-6.912c-.216.648-.4,1.368-.612,2.052H6.984c-.216-.684-.4-1.4-.612-2.052L4.608-11.7H1.3ZM17.82-5.688c.288-1.116.576-2.52.828-3.708h.072c.288,1.17.576,2.592.864,3.708l.2.81h-2.16ZM13.32,0h3.168l.576-2.484H20.34L20.916,0h3.276L20.628-11.7H16.884ZM24.84,0h3.1V-3.924h1.188L31.14,0H34.6L32.058-4.536a3.589,3.589,0,0,0,1.89-3.384c0-2.916-2.16-3.78-4.68-3.78H24.84Zm3.1-6.372v-2.88h1.116c1.224,0,1.872.324,1.872,1.332s-.648,1.548-1.872,1.548ZM35.712,0h3.1V-2.916L39.924-4.5,42.516,0H45.9L41.724-6.948,45.216-11.7H41.832L38.88-7.344h-.072V-11.7h-3.1ZM46.548,0h7.74V-2.592H49.644V-4.68H53.46V-7.272H49.644V-9.108h4.464V-11.7h-7.56ZM58.32,0h3.1V-9.108h3.1V-11.7H55.224v2.592h3.1Z",
    transform: "translate(875.617 685.25)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6714",
    "data-name": "Path 6714",
    d: "M-204-2303s113.834-65.192,143.769,44.51",
    transform: "translate(522.604 2962.25)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6715",
    "data-name": "Path 6715",
    d: "M-69.224-2252.3S-26.71-2353.866,68.4-2269.739",
    transform: "translate(554.464 2962.25)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6716",
    "data-name": "Path 6716",
    d: "M94.316-2264s78.459-123.533,209.388-29.123",
    transform: "translate(573.894 2962.25)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6718",
    "data-name": "Path 6718",
    d: "M349-2303s113.929-84.518,142.689,72.056",
    transform: "translate(597.505 2962.25)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6719",
    "data-name": "Path 6719",
    d: "M544.137-2206.017s117.508,21.6,126.411-92.016c.3-3.863.505-7.6.618-11.357",
    transform: "translate(610.035 2959.18)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(213.518 639.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M5.007,0,.455,9.1,0,.91Z",
    transform: "translate(556.277 73.771) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M31.409,4.324,0,22.987,8.194,0Z",
    transform: "translate(613.217 7.823) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M24.539,9.131,10.082,19.023,0,0Z",
    transform: "translate(577.279 88.187) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M16.16,15.022,7.966,0,0,26.857Z",
    transform: "translate(822.965 24.25) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M6.6,1.366,5.007,6.373,0,0Z",
    transform: "translate(677.949 3.523) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M22.3,10.47,14.566,0,0,12.063Z",
    transform: "translate(329.402 31.701) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M3.869,5.007,3.186,0,0,6.6Z",
    transform: "translate(381.318 87.832) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M10.854,0,8.214,12.614,0,13.2Z",
    transform: "translate(392.845 52.627) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M17.753,0,15.932,28.905,0,10.925Z",
    transform: "translate(32.515 7.481) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M25.29,22.563,5.442,0,0,27.72Z",
    transform: "translate(1029.443 8.673) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M11.835,3.414,0,0,3.869,17.98Z",
    transform: "translate(216.273 22.53) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M2.012,0,13.584,7.8,0,23.9Z",
    transform: "translate(175.589 108.795) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M6.828,5.69,10.925,0,0,1.138Z",
    transform: "translate(337.341 111.904) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M4.1,2.5.455,0,0,9.559Z",
    transform: "translate(21.404 63.04) rotate(105)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M8.194,0,0,1.593,5.462,9.787Z",
    transform: "translate(440.176 47.092) rotate(105)",
    fill: "#701FFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(635.504 677.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5978",
    "data-name": "Path 5978",
    d: "M919.7,122.651l1.9-3.128-1.869-1.37a9.228,9.228,0,0,0,.491-3.174l2.2-.74-.866-3.554-2.29.353a9.238,9.238,0,0,0-1.9-2.592l1.029-2.077-3.128-1.9-1.371,1.869a9.289,9.289,0,0,0-3.173-.49l-.741-2.2-3.553.866.353,2.29a9.224,9.224,0,0,0-2.592,1.9l-2.077-1.029-1.9,3.128,1.869,1.37a9.266,9.266,0,0,0-.49,3.174l-2.2.741.867,3.553,2.29-.353a9.275,9.275,0,0,0,1.9,2.592l-1.029,2.077,3.128,1.9,1.371-1.869a9.241,9.241,0,0,0,3.173.49l.741,2.2,3.554-.866-.354-2.29a9.255,9.255,0,0,0,2.592-1.9Zm-12.226-1.843a6.607,6.607,0,1,1,9.078-2.213A6.608,6.608,0,0,1,907.474,120.808Z",
    transform: "translate(-876.885 -80.555)",
    fill: "#edf1f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(46.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(7.513 25.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6034",
    "data-name": "Path 6034",
    d: "M953.571,110.671a2.488,2.488,0,0,0,.305,2.926c.415.411,1.391.264,1.657.286a15.3,15.3,0,0,0,2.767,2.147,11.726,11.726,0,0,0,2.544-2.432c-.729-.793-1.446-1.363-2.229-2.156a4.559,4.559,0,0,0-2.772-1.685A4.076,4.076,0,0,0,953.571,110.671Z",
    transform: "translate(-949.654 -108.619)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6035",
    "data-name": "Path 6035",
    d: "M948.954,108.87c-.17-.184.082-.938.3-.863a4.956,4.956,0,0,1,1.626,1.055,2.965,2.965,0,0,0,1.9.725,17.162,17.162,0,0,0,1.906-.058c.332-.023.319.44-.011.462l-.392.027a.23.23,0,0,1-.124.383,4.063,4.063,0,0,1-3.4-.15A11.865,11.865,0,0,1,948.954,108.87Z",
    transform: "translate(-948.134 -108.001)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6036",
    "data-name": "Path 6036",
    d: "M947.839,111.593c-.17-.184.029-.829.148-.825a2.739,2.739,0,0,1,1.724.837,2.966,2.966,0,0,0,1.9.726,17.007,17.007,0,0,0,1.906-.058c.332-.022.319.44-.011.462l-.393.028a.23.23,0,0,1-.124.383,4.063,4.063,0,0,1-3.4-.15A10.446,10.446,0,0,1,947.839,111.593Z",
    transform: "translate(-947.738 -108.976)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M948.756,113.819c-.209-.147-.488-.277-.453-.545.014-.1.043-.378.161-.4.757-.117,1.3.35,1.932.671a3.077,3.077,0,0,0,2.027.346,17.042,17.042,0,0,0,1.848-.422.233.233,0,1,1,.1.453l-.377.1c.149.089.675.567.5.663a5.274,5.274,0,0,1-3.894.239A9.8,9.8,0,0,1,948.756,113.819Z",
    transform: "translate(-947.923 -109.713)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6038",
    "data-name": "Path 6038",
    d: "M947.769,110.249c-.17-.184.128-.864.374-.785a3.8,3.8,0,0,1,1.5.818,2.966,2.966,0,0,0,1.9.726,17.171,17.171,0,0,0,1.906-.058c.332-.022.319.44-.011.462l-.393.028a.23.23,0,0,1-.125.383,4.063,4.063,0,0,1-3.4-.15A10.534,10.534,0,0,1,947.769,110.249Z",
    transform: "translate(-947.719 -108.514)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6039",
    "data-name": "Path 6039",
    d: "M953.573,111.341a2.363,2.363,0,0,0,.217,2.761A9.3,9.3,0,0,1,953.573,111.341Z",
    transform: "translate(-949.657 -109.178)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6040",
    "data-name": "Path 6040",
    d: "M955.7,110.912a1.53,1.53,0,0,0,.88,1.566s-.929-.489-1.067-.81A.753.753,0,0,1,955.7,110.912Z",
    transform: "translate(-950.449 -109.027)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(0 10.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6041",
    "data-name": "Path 6041",
    d: "M940.579,103.54,951.9,100.7l-3.469-15.173L937.11,88.368Z",
    transform: "translate(-936.468 -85.098)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6042",
    "data-name": "Path 6042",
    d: "M936.754,87.907l8.578-2.108.132.573-1.907.488-6.162,1.531a.962.962,0,0,0-.606,1.183l2.887,12.652a.909.909,0,0,0,1.054.759l8.074-2,.278,1.2-8.562,2.174a.909.909,0,0,1-1.053-.76l-3.318-14.515A.961.961,0,0,1,936.754,87.907Z",
    transform: "translate(-936.119 -85.196)",
    fill: "#3d495f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6043",
    "data-name": "Path 6043",
    d: "M936.831,88.659l3.317,14.515a.919.919,0,0,0,1,.771l.057-.012,10.3-2.584a.962.962,0,0,0,.6-1.184L948.791,85.65a.909.909,0,0,0-1.053-.76l-10.3,2.584-.057.017A.977.977,0,0,0,936.831,88.659Zm13.885,11.566-9.3,2.33a.909.909,0,0,1-1.054-.759l-2.887-12.652a.962.962,0,0,1,.606-1.183l9.3-2.329a.908.908,0,0,1,1.054.759l2.886,12.651A.961.961,0,0,1,950.716,100.225Z",
    transform: "translate(-936.359 -84.867)",
    fill: "#53607d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6044",
    "data-name": "Path 6044",
    d: "M950.618,111.455,952,111.1a.291.291,0,0,0,.183-.358h0a.274.274,0,0,0-.319-.229l-1.38.353a.291.291,0,0,0-.183.358h0A.275.275,0,0,0,950.618,111.455Z",
    transform: "translate(-941.111 -93.9)",
    fill: "#3d495f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6045",
    "data-name": "Path 6045",
    d: "M952.843,108.213c-.109-.116.06-.908.332-.93a4.53,4.53,0,0,1,2.441.632,9.658,9.658,0,0,1,2.284,2.168c.1.159-.733-.071-.876-.027a.224.224,0,0,1-.19.179c-.965.106-1.225-.733-1.93-1.183S953.356,108.758,952.843,108.213Z",
    transform: "translate(-941.999 -81.832)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(51.249 95.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6046",
    "data-name": "Path 6046",
    d: "M1020.5,215.861c.776.263-2.262,2.938-2.262,2.938l-3,.329s1.538-.817,3.041-1.7C1020,216.429,1019.9,215.656,1020.5,215.861Z",
    transform: "translate(-1015.242 -215.828)",
    fill: "#e8a148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6047",
    "data-name": "Path 6047",
    d: "M1018.166,221.227l-2.858.072-.067-.614,3.985-.437Z",
    transform: "translate(-1015.242 -217.385)",
    fill: "#e38038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(53.199 94.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6048",
    "data-name": "Path 6048",
    d: "M1018.253,217.969c.3-.559.725-1.106,1.1-1.832.9-1.773.4-2.366,1.021-2.522.8-.2,2.707,1.252,2.707,1.252l-3.93,3.172Z",
    transform: "translate(-1018.253 -213.597)",
    fill: "#e8a148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6049",
    "data-name": "Path 6049",
    d: "M1019.633,218.732l3.93-3.172.389.481-4.238,3.536C1019.692,219.574,1019.633,218.732,1019.633,218.732Z",
    transform: "translate(-1018.739 -214.288)",
    fill: "#e38038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(28.57 96.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6050",
    "data-name": "Path 6050",
    d: "M985.455,217.112c.7.32,1.255,2.5,1.255,2.5l-6.482.04s1.514-.614,3-1.289C984.932,217.593,984.908,216.861,985.455,217.112Z",
    transform: "translate(-980.228 -217.062)",
    fill: "#e8a148"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    width: 6.482,
    height: 0.58,
    transform: "translate(0.018 2.563) rotate(-0.349)",
    fill: "#e38038"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6051",
    "data-name": "Path 6051",
    d: "M985.875,136.885c-2.3,13.4-.275,52.806-.275,52.806l2.107-.113s9-37.017,9.591-38.5-.29-11.3-.29-11.3Z",
    transform: "translate(-953.26 -92.263)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6052",
    "data-name": "Path 6052",
    d: "M993.729,151.63c.5-1.383,5.528-8.4,5.528-8.4s.229,8.591-.365,10.08-9.591,38.5-9.591,38.5S993.175,153.162,993.729,151.63Z",
    transform: "translate(-954.854 -94.499)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6053",
    "data-name": "Path 6053",
    d: "M1009.864,187.474l-8.808-18.055L993.744,148.6l-2.753-2.111.44-10.176,14.191,1.132.947,29.436L1012,186.372Z",
    transform: "translate(-955.45 -92.062)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6054",
    "data-name": "Path 6054",
    d: "M994.455,156.716l3.65-2.976-3.511.962-2.753-1.566Z",
    transform: "translate(-955.749 -97.989)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6055",
    "data-name": "Path 6055",
    d: "M1002.655,167.335s-.293-18.1-3.121-23.153c-1.535-2.74-13.947-2.868-13.947-2.868l.59-5.554,17.541,1.492.948,29.436,5.432,19.489-.512.264Z",
    transform: "translate(-953.546 -91.867)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6056",
    "data-name": "Path 6056",
    d: "M983.867,108.11s-3.475,9.329-11.823,12.013c-3.926,1.262-14.539-8.146-14.539-8.146l2.633-4.61s9.413,5.354,9.894,5.277c1.295-.207,6.322-10.647,10.844-11.66C982.763,100.562,984.607,104.695,983.867,108.11Z",
    transform: "translate(-943.653 -79.605)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6057",
    "data-name": "Path 6057",
    d: "M978.743,105.414s-3.529,12.471-7.254,13.6c-2.748.837-13.985-5.47-13.985-5.47s9.289,8.751,13.877,8.276,9.77-7.61,9.77-7.61Z",
    transform: "translate(-943.653 -81.176)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6058",
    "data-name": "Path 6058",
    d: "M995.857,98.91c-3.7-.14-6.277,1.2-7.1,3.348-4.29,11.251-4.443,24.11-4.443,24.11s12.465,3.252,19.364,1.9c0,0,2.079-19.595-.253-25.241C1001.83,99.162,998.512,99.009,995.857,98.91Z",
    transform: "translate(-953.099 -78.881)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6059",
    "data-name": "Path 6059",
    d: "M994.47,92.439c.073.188.142.365.193.529a9.035,9.035,0,0,1,.319,1.325,10.281,10.281,0,0,1,.148,1.222,11.362,11.362,0,0,1-.045,2.11c3.457,1.705,7.2-.643,7.2-.643a11.274,11.274,0,0,1-.4-1.665,25.594,25.594,0,0,1-.313-2.781.211.211,0,0,1-.006-.057.235.235,0,0,1-.006-.04h-7.1Z",
    transform: "translate(-956.675 -76.605)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6060",
    "data-name": "Path 6060",
    d: "M994.47,92.439c.073.188.142.365.193.529a5.437,5.437,0,0,1,.319,1.325,10.281,10.281,0,0,1,.148,1.222,8.492,8.492,0,0,0,4.844.722,4.587,4.587,0,0,0,1.917-.921,25.594,25.594,0,0,1-.313-2.781.211.211,0,0,1-.006-.057.235.235,0,0,1-.006-.04h-7.1Z",
    transform: "translate(-956.675 -76.605)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6061",
    "data-name": "Path 6061",
    d: "M1004.624,98.384a12.4,12.4,0,0,1-6.418,1.9,11.2,11.2,0,0,1,.826,2.262S1003.794,101.2,1004.624,98.384Z",
    transform: "translate(-957.991 -78.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6062",
    "data-name": "Path 6062",
    d: "M995.875,100.216s.282.477,1.371.693l-1.753,1.583s-.025-1.909,0-2.182S995.875,100.216,995.875,100.216Z",
    transform: "translate(-957.032 -79.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6063",
    "data-name": "Path 6063",
    d: "M1000.691,116.509s1.013,2.01-.96,4.763c-2.347,3.273-7.328,9.754-15.413,10.561,0,0,12.595,3.472,19.364,1.9,0,0,1.22-13.978.853-18.819C1004.4,113.182,1000.691,116.509,1000.691,116.509Z",
    transform: "translate(-953.099 -84.348)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854",
    transform: "translate(45.689 45.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6064",
    "data-name": "Path 6064",
    d: "M1009.407,146.563a.758.758,0,0,0,.915-.087.769.769,0,0,0,.355.414.692.692,0,0,0,.94-.191.617.617,0,0,0,.575.383.835.835,0,0,0,.722-.284.517.517,0,0,0,.742.284c.786-.51.819-1.843.79-2.685a2.3,2.3,0,0,0-1.186-2.267,2.92,2.92,0,0,0-3.542,1.685c0,.008-.012.009-.016.017C1009.381,144.479,1008.418,146.082,1009.407,146.563Z",
    transform: "translate(-1007.474 -139.494)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M1008.327,142.05a6.191,6.191,0,0,1,2.33-.061.388.388,0,0,1,.042.013.5.5,0,0,1,.418.812c-.381.429-.85.917-1.416.88-.312-.019-.583-.29-.892-.214-.4.1-.731.716-.905,1.058-.3.586-1.425-.089-1.22-.7A2.905,2.905,0,0,1,1008.327,142.05Z",
    transform: "translate(-1006.659 -139.474)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M1012.73,141.505l1.676-3.356,2.779,1.829-1.982,3.06Z",
    transform: "translate(-1008.797 -138.149)",
    fill: "#f5b379"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6067",
    "data-name": "Path 6067",
    d: "M1009.915,101s11.52,5.817,13.679,14.316c1.015,4-7.872,13.752-7.872,13.752l-4.437-2.915s5.394-7.678,5.347-8.164c-.125-1.305-5.922-4.1-7.395-6.208C1008.72,108.936,1007.781,104.091,1009.915,101Z",
    transform: "translate(-961.646 -79.621)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6068",
    "data-name": "Path 6068",
    d: "M1009.6,117.647s9.607,2.82,8.636,5.789-6.589,8.582-6.589,8.582,5.455-7.286,5.348-8.164S1010.608,119.631,1009.6,117.647Z",
    transform: "translate(-962.004 -85.486)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6069",
    "data-name": "Path 6069",
    d: "M1008.417,76.722s3.524,7.125-4.228,11.588l-.716-5.941,2.694-4.26Z",
    transform: "translate(-959.847 -71.069)",
    fill: "#5d3e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6070",
    "data-name": "Path 6070",
    d: "M1001.176,84.314s-.567,3.775-1.908,4.52-6.047.808-7.046-.389-.811-11.065-.436-11.834,6.882-3.625,9.091-.479S1001.176,84.314,1001.176,84.314Z",
    transform: "translate(-955.623 -70.351)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6071",
    "data-name": "Path 6071",
    d: "M1000.258,79.626a6.485,6.485,0,0,0-2.976-.6,1.744,1.744,0,0,0-.137,1.3,13.053,13.053,0,0,0,2.919.085A1.779,1.779,0,0,0,1000.258,79.626Z",
    transform: "translate(-957.593 -71.865)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6072",
    "data-name": "Path 6072",
    d: "M990.369,79.712a6.086,6.086,0,0,1,2.79-.826,1.747,1.747,0,0,1,.181,1.282,11.994,11.994,0,0,1-2.757.306A1.766,1.766,0,0,1,990.369,79.712Z",
    transform: "translate(-955.228 -71.823)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6073",
    "data-name": "Path 6073",
    d: "M998.8,83.76c-.094.549-.429.91-.769.811-.357-.106-.59-.683-.5-1.3s.475-1,.836-.825A1.256,1.256,0,0,1,998.8,83.76Z",
    transform: "translate(-957.748 -73.072)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6074",
    "data-name": "Path 6074",
    d: "M993.076,83.7c-.025.558-.262,1-.543.994s-.516-.5-.49-1.1.29-1.05.581-1S993.1,83.14,993.076,83.7Z",
    transform: "translate(-955.82 -73.135)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855",
    transform: "translate(36.933 15.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6075",
    "data-name": "Path 6075",
    d: "M996.009,91.976a4.239,4.239,0,0,1-2.869-.175s0,1.518.955,1.78S995.613,92.767,996.009,91.976Z",
    transform: "translate(-993.14 -91.801)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(37.022 11.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6076",
    "data-name": "Path 6076",
    d: "M994.368,85.756s-.9,1.97-.7,2.491,1.674.227,1.674.227Z",
    transform: "translate(-993.405 -85.756)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6077",
    "data-name": "Path 6077",
    d: "M994.239,85.756c-.065.372-.142.733-.236,1.083s-.185.7-.232,1.028c-.026.166-.025.311.012.329a.7.7,0,0,0,.361.159,9.78,9.78,0,0,0,1.074.12,2.6,2.6,0,0,1-1.115.257.96.96,0,0,1-.651-.216.593.593,0,0,1-.172-.389,1.631,1.631,0,0,1,.01-.327A4.71,4.71,0,0,1,994.239,85.756Z",
    transform: "translate(-993.276 -85.756)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6078",
    "data-name": "Path 6078",
    d: "M1004.685,74.161a5.157,5.157,0,0,0-1.347-.512c.648.829,1.438,5.1-.589,7.837a1.151,1.151,0,0,1-1.645.415.02.02,0,0,1-.013-.006c-1.373-1.27-1.768-3.8-1.847-6.859-1.956-1.166-5.952-1.321-8.31-.784a.63.63,0,0,1-.11.013c-1.075-.019-2.209-3.679-1.587-5.37,0-.006.007-.013.007-.019a1.132,1.132,0,0,1,1.062-.829c3.413-.071,10.389-.654,12.611,4.715a2.916,2.916,0,0,0,.57-1.963c-.026-.363.545-.337.563.026a3.387,3.387,0,0,1-.654,2.254,5.729,5.729,0,0,1,1.593.6C1005.3,73.863,1005,74.342,1004.685,74.161Z",
    transform: "translate(-954.769 -67.994)",
    fill: "#5d3e4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6079",
    "data-name": "Path 6079",
    d: "M1001.1,82.391a.02.02,0,0,1-.013-.006c-1.373-1.27-1.768-3.8-1.847-6.859-1.956-1.166-5.952-1.321-8.31-.784a.63.63,0,0,1-.11.013c-1.075-.019-2.209-3.679-1.587-5.37-.376,1.211.733,2.5,2.274,3.2,2.4,1.095,9.786-1.2,9.107,1.555C999.73,77.759,1001.375,82.553,1001.1,82.391Z",
    transform: "translate(-954.769 -68.484)",
    fill: "#4a2f3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    transform: "translate(44.77 11.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6080",
    "data-name": "Path 6080",
    d: "M1005.8,86.065c.449-.461,2.351-1.008,2.588-.247.381,1.216-1.088,3.562-2.842,2.61C1004.906,88.081,1005.409,86.464,1005.8,86.065Z",
    transform: "translate(-1005.239 -85.44)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6081",
    "data-name": "Path 6081",
    d: "M1006.619,87.271s1.394-.913,1.525-.5c.256.808-.891,1.474-1.219,1.591,0,0,.64-.7.475-1S1006.619,87.271,1006.619,87.271Z",
    transform: "translate(-1005.725 -85.871)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858",
    transform: "translate(2.878 15.064)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 0.879,
    height: 10.882,
    transform: "translate(0 0.206) rotate(-13.568)",
    fill: "#9ed1de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 0.879,
    height: 5.441,
    transform: "translate(3.004 5.079) rotate(-13.568)",
    fill: "#9ed1de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 0.878,
    height: 7.376,
    transform: "translate(4.299 2.822) rotate(-13.574)",
    fill: "#9ed1de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    width: 0.879,
    height: 3.855,
    transform: "translate(6.833 5.786) rotate(-13.568)",
    fill: "#9ed1de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 0.878,
    height: 6.239,
    transform: "translate(8.021 3.094) rotate(-13.574)",
    fill: "#9ed1de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(0 45.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(0 5.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6089",
    "data-name": "Path 6089",
    d: "M909.379,152.086a24.4,24.4,0,0,0-16.1-6.09v-.007l-4.274.367a24.505,24.505,0,0,0,0,48.286l4.274.361V195a24.5,24.5,0,0,0,16.1-42.91Z",
    transform: "translate(-866.071 -145.989)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 24.507,
    cy: 24.507,
    r: 24.507,
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 19.606,
    cy: 19.606,
    r: 19.606,
    transform: "translate(4.901 4.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 14.716,
    cy: 14.716,
    r: 14.716,
    transform: "translate(9.791 9.791)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 9.924,
    cy: 9.924,
    r: 9.924,
    transform: "translate(14.583 14.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 6.043,
    cy: 6.043,
    rx: 6.043,
    ry: 6.043,
    transform: "translate(18.464 18.464)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 2.626,
    cy: 2.626,
    r: 2.626,
    transform: "translate(21.881 21.881)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(23.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    transform: "translate(23.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6090",
    "data-name": "Path 6090",
    d: "M952.64,148.426l-4.634-2.36-8.461,6.344,4.635,2.359Z",
    transform: "translate(-938.617 -141.007)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6091",
    "data-name": "Path 6091",
    d: "M946.572,138.255l-8.46,6.344.966,5.109,8.46-6.344Z",
    transform: "translate(-938.112 -138.255)",
    fill: "#701FFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6092",
    "data-name": "Path 6092",
    d: "M901.481,169.71a.553.553,0,0,0,.749.8l33.8-25.655a.552.552,0,0,0-.668-.88l-33.8,25.655A.527.527,0,0,0,901.481,169.71Z",
    transform: "translate(-901.344 -140.232)",
    fill: "#333"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "logo-background-opactity-3",
    "data-name": "logo-background-opactity",
    width: 15,
    height: 14,
    transform: "translate(830 725)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "logo-background-opactity-4",
    "data-name": "logo-background-opactity",
    width: 22,
    height: 21,
    transform: "translate(1199 694)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6726",
    "data-name": "Path 6726",
    d: "M1.3,0H4.068V-3.456c0-1.188-.252-3.348-.4-4.536h.072L4.68-4.824,6.12-.954H7.776l1.44-3.87.972-3.168h.072c-.144,1.188-.4,3.348-.4,4.536V0h2.808V-11.7H9.36L7.668-6.912c-.216.648-.4,1.368-.612,2.052H6.984c-.216-.684-.4-1.4-.612-2.052L4.608-11.7H1.3ZM14.8,0h7.74V-2.592H17.892V-4.68h3.816V-7.272H17.892V-9.108h4.464V-11.7H14.8ZM27.36-5.688c.288-1.116.576-2.52.828-3.708h.072c.288,1.17.576,2.592.864,3.708l.2.81h-2.16ZM22.86,0h3.168L26.6-2.484H29.88L30.456,0h3.276L30.168-11.7H26.424ZM38.088.216C41,.216,42.66-1.548,42.66-3.528a3.216,3.216,0,0,0-2.286-3.2L38.952-7.29C37.89-7.7,37.224-7.9,37.224-8.46c0-.522.468-.792,1.224-.792a4.189,4.189,0,0,1,2.268.828l1.62-2.016a5.79,5.79,0,0,0-3.888-1.476c-2.556,0-4.356,1.638-4.356,3.636A3.457,3.457,0,0,0,36.45-5.022l1.458.612c.99.4,1.584.576,1.584,1.134,0,.522-.4.828-1.332.828a4.724,4.724,0,0,1-2.88-1.044L33.66-1.476A6.4,6.4,0,0,0,38.088.216Zm10.764,0c3.276,0,4.788-1.872,4.788-5.868V-11.7H50.652v6.408c0,2.088-.576,2.844-1.8,2.844S47.088-3.2,47.088-5.292V-11.7h-3.1v6.048C43.992-1.656,45.576.216,48.852.216ZM55.692,0h3.1V-3.924h1.188L61.992,0h3.456L62.91-4.536A3.589,3.589,0,0,0,64.8-7.92c0-2.916-2.16-3.78-4.68-3.78H55.692Zm3.1-6.372v-2.88H59.9c1.224,0,1.872.324,1.872,1.332S61.128-6.372,59.9-6.372ZM66.564,0H74.3V-2.592H69.66V-4.68h3.816V-7.272H69.66V-9.108h4.464V-11.7h-7.56Z",
    transform: "translate(1095 744.85)",
    fill: "#701FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(1108.545 679.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(38.291 37.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6614",
    "data-name": "Path 6614",
    d: "M266.385,617.871a2.487,2.487,0,0,0,1.134,2.713c.516.274,1.408-.148,1.669-.2.628.378,3.226-2.691,2.248-3.225a4.557,4.557,0,0,0-3.141-.814A4.067,4.067,0,0,0,266.385,617.871Z",
    transform: "translate(-262.47 -615.306)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    "data-name": "Path 6615",
    d: "M261.256,617.863c-.216-.128-.192-.922.036-.913a4.959,4.959,0,0,1,1.862.542,2.964,2.964,0,0,0,2.025.148,17.109,17.109,0,0,0,1.808-.6c.312-.117.432.33.123.446l-.368.139a.231.231,0,0,1-.01.4,4.065,4.065,0,0,1-3.3.836A11.754,11.754,0,0,1,261.256,617.863Z",
    transform: "translate(-260.647 -615.539)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6616",
    "data-name": "Path 6616",
    d: "M260.958,620.719c-.216-.127-.212-.8-.1-.832a2.734,2.734,0,0,1,1.892.305,2.964,2.964,0,0,0,2.025.149,17.271,17.271,0,0,0,1.808-.6c.312-.118.432.329.123.446l-.368.14a.23.23,0,0,1-.009.4,4.065,4.065,0,0,1-3.3.837A10.493,10.493,0,0,1,260.958,620.719Z",
    transform: "translate(-260.533 -616.513)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    "data-name": "Path 6617",
    d: "M262.461,622.074c-.244-.08-.547-.124-.591-.391-.016-.1-.067-.374.04-.426a3.153,3.153,0,0,1,2.044.086,3.074,3.074,0,0,0,2.04-.253,17.037,17.037,0,0,0,1.648-.936.233.233,0,1,1,.227.4l-.332.207c.168.042,1.579.058,1.467.22-.6.873-3.274,1.733-4.452,1.622A9.918,9.918,0,0,1,262.461,622.074Z",
    transform: "translate(-260.906 -616.653)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6618",
    "data-name": "Path 6618",
    d: "M260.518,619.446c-.216-.127-.126-.865.132-.859a3.812,3.812,0,0,1,1.667.352,2.963,2.963,0,0,0,2.025.149,17.263,17.263,0,0,0,1.808-.6c.312-.118.432.329.123.446l-.368.14a.23.23,0,0,1-.01.4,4.065,4.065,0,0,1-3.3.837A10.494,10.494,0,0,1,260.518,619.446Z",
    transform: "translate(-260.397 -616.072)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    "data-name": "Path 6619",
    d: "M264.8,615.988c-.137-.08-.205-.887.049-.985a4.521,4.521,0,0,1,2.519-.1,9.686,9.686,0,0,1,2.812,1.417c.145.122-.723.143-.847.227a.225.225,0,0,1-.13.227c-.894.38-1.384-.349-2.189-.578S265.453,616.363,264.8,615.988Z",
    transform: "translate(-261.906 -614.772)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6620",
    "data-name": "Path 6620",
    d: "M266.451,618.9a2.363,2.363,0,0,0,1,2.581A9.315,9.315,0,0,1,266.451,618.9Z",
    transform: "translate(-262.504 -616.225)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6621",
    "data-name": "Path 6621",
    d: "M268.29,617.891s.057.918,1.295,1.246a3.415,3.415,0,0,1-1.255-.468A.755.755,0,0,1,268.29,617.891Z",
    transform: "translate(-263.144 -615.871)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6622",
    "data-name": "Path 6622",
    d: "M308.6,597.094s-3.475,9.329-11.823,12.013c-3.926,1.262-2.493-7.4-2.012-7.479,1.295-.206,10.034-11.4,10.034-11.4A34,34,0,0,0,308.6,597.094Z",
    transform: "translate(-233.982 -569.088)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    "data-name": "Path 6623",
    d: "M303.069,594.24s-3.529,12.472-7.254,13.605c-2.748.836-4.7,3.279-.108,2.807s9.769-7.611,9.769-7.611Z",
    transform: "translate(-233.576 -570.5)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(75.027 93.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    "data-name": "Path 6624",
    d: "M322.356,702.464c.7.324,1.238,2.51,1.238,2.51h-6.482s1.518-.6,3.011-1.27C321.83,702.942,321.81,702.21,322.356,702.464Z",
    transform: "translate(-317.113 -702.413)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 6.482,
    height: 0.58,
    transform: "translate(0.001 2.561)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(57.431 93.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    d: "M295.19,702.464c.7.324,1.238,2.51,1.238,2.51h-6.482s1.518-.6,3.011-1.27C294.664,702.942,294.644,702.21,295.19,702.464Z",
    transform: "translate(-289.947 -702.413)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 6.482,
    height: 0.58,
    transform: "translate(0 2.561)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6626",
    "data-name": "Path 6626",
    d: "M301.586,630.779l-5.467,46.895,2,.148,12.219-32.1.841-14.948Z",
    transform: "translate(-234.69 -583.373)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    d: "M311.055,650.953l-12.219,32.1-.675-.05,10.383-37.384Z",
    transform: "translate(-235.409 -588.599)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    "data-name": "Path 6628",
    d: "M325.113,630.779s1.151,27.989-3.136,47.34h-2.351l-5.761-47.34Z",
    transform: "translate(-240.941 -583.373)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    "data-name": "Path 6629",
    d: "M303.828,633.806s14.289-1.154,14.289,3.222-.356,41.091-.356,41.091h.68s3.848-32.048,3.136-47.34H304.3Z",
    transform: "translate(-237.406 -583.373)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    "data-name": "Path 6630",
    d: "M314.092,587.734c-3.7-.139-6.394.841-7.32,2.945s-4.291,26.418-4.291,26.418,12.536,1.347,19.435,0c0,0,2.428-19.492,1.084-25.838C322.346,588.168,316.746,587.834,314.092,587.734Z",
    transform: "translate(-236.931 -568.204)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    d: "M315.374,642.237l-3.475,1.152-3.867-1.993,3.688,4.151Z",
    transform: "translate(-238.887 -587.113)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M313.087,581.206c.074.188.142.364.194.529a9.121,9.121,0,0,1,.318,1.325,10.167,10.167,0,0,1,.148,1.223,11.359,11.359,0,0,1-.045,2.109c3.457,1.706,7.2-.642,7.2-.642a11.416,11.416,0,0,1-.4-1.666,25.576,25.576,0,0,1-.313-2.78.21.21,0,0,1-.006-.057.234.234,0,0,1-.006-.04h-7.1Z",
    transform: "translate(-240.668 -565.909)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    d: "M313.087,581.206c.074.188.142.364.194.529a5.464,5.464,0,0,1,.318,1.325,10.166,10.166,0,0,1,.148,1.223,8.491,8.491,0,0,0,4.844.722,4.577,4.577,0,0,0,1.916-.921,25.565,25.565,0,0,1-.313-2.78.21.21,0,0,1-.006-.057.233.233,0,0,1-.006-.04h-7.1Z",
    transform: "translate(-240.668 -565.908)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M321.129,572.167s-.567,3.775-1.908,4.52-6.047.808-7.046-.389-.81-11.065-.435-11.834,6.882-3.625,9.091-.479S321.129,572.167,321.129,572.167Z",
    transform: "translate(-240.087 -559.332)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M308.792,558.884c1.383-1.538,5.069-1.449,8.479-1.038,2.808.339,4.664,3.716,4.626,3.866.7.229,1.255,1.976,1.021,3.206-.877,4.61-3.22,5.417-3.661,5.294-2.042-.573-2.22-4.378-1.088-7.3a14.806,14.806,0,0,0-5.284.026c-.86.2-3.459.476-4.335-.052C307.249,562.106,308.029,559.731,308.792,558.884Z",
    transform: "translate(-238.824 -557.588)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M320.2,567.052a6.488,6.488,0,0,0-3.02-.309,1.74,1.74,0,0,0-.008,1.31,12.971,12.971,0,0,0,2.913-.2A1.764,1.764,0,0,0,320.2,567.052Z",
    transform: "translate(-242.063 -560.787)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M310.323,567.566a6.068,6.068,0,0,1,2.79-.827,1.748,1.748,0,0,1,.181,1.282,12.029,12.029,0,0,1-2.757.306A1.767,1.767,0,0,1,310.323,567.566Z",
    transform: "translate(-239.691 -560.804)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M318.758,571.614c-.094.549-.429.91-.769.811-.357-.106-.59-.683-.5-1.3s.475-1,.836-.826A1.261,1.261,0,0,1,318.758,571.614Z",
    transform: "translate(-242.212 -562.053)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    d: "M313.03,571.553c-.025.558-.262,1-.543.994s-.516-.5-.49-1.1.291-1.05.582-1S313.055,570.994,313.03,571.553Z",
    transform: "translate(-240.283 -562.117)",
    fill: "#503d39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    "data-name": "Path 6640",
    d: "M319.168,574.591a.278.278,0,0,0-.435.056,13.011,13.011,0,0,0-.428,1.674c-.465,1.608-2.349,1.762-3.652,1.1-.646-.328-.72-1.1-1.15-1.645-.047-.06-1.048-.106-1.089.1-.227,1.157-1.285.7-1.628,1.53a22.812,22.812,0,0,0-.341,3.228c-.008,1.407.33,2.847,1.544,3.083,1.4.274,5.66-.526,6.6-1.748a16.22,16.22,0,0,0,2.723-5.458C321.36,576.269,319.362,574.823,319.168,574.591Z",
    transform: "translate(-239.736 -563.55)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    d: "M309.442,578.4a10.769,10.769,0,0,1,2.476-1c.485.039,1.064.126,1.472.2a8.61,8.61,0,0,1,2.476,1.293c.209.24-1.956.62-3.487.528S309.827,578.994,309.442,578.4Z",
    transform: "translate(-239.384 -564.569)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(71.733 14.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    "data-name": "Path 6642",
    d: "M314.9,579.83a4.237,4.237,0,0,1-2.868-.175s0,1.518.955,1.78S314.5,580.621,314.9,579.83Z",
    transform: "translate(-312.027 -579.655)",
    fill: "#4c2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    d: "M312.027,579.655a2.528,2.528,0,0,0,.231.68,3.867,3.867,0,0,0,2.287.148,4.772,4.772,0,0,0,.35-.654A4.671,4.671,0,0,1,312.027,579.655Z",
    transform: "translate(-312.027 -579.655)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(72.512 10.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    "data-name": "Path 6644",
    d: "M314.321,573.609s-.9,1.97-.7,2.491,1.674.228,1.674.228Z",
    transform: "translate(-313.358 -573.609)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M314.192,573.609q-.1.559-.235,1.084c-.085.35-.185.7-.233,1.028-.026.165-.026.31.012.328a.69.69,0,0,0,.36.159,9.894,9.894,0,0,0,1.074.12,2.609,2.609,0,0,1-1.115.256.954.954,0,0,1-.65-.216.592.592,0,0,1-.172-.389,1.678,1.678,0,0,1,.01-.327A4.72,4.72,0,0,1,314.192,573.609Z",
    transform: "translate(-313.23 -573.609)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M324.522,563.955s2.461,1.343.312,5.616-3.332,7.561-4.534,8.686-4.992,1.75-4.992,1.75,5.487-3.022,6.708-7.015C322.612,571.042,324.887,566.542,324.522,563.955Z",
    transform: "translate(-241.45 -559.831)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(80.261 10.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    "data-name": "Path 6647",
    d: "M325.752,573.919c.449-.46,2.351-1.008,2.589-.247.381,1.216-1.088,3.562-2.842,2.61C324.859,575.935,325.363,574.318,325.752,573.919Z",
    transform: "translate(-325.193 -573.294)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    "data-name": "Path 6648",
    d: "M326.573,575.125s1.393-.914,1.525-.5c.257.807-.891,1.474-1.22,1.591,0,0,.641-.7.475-1S326.573,575.125,326.573,575.125Z",
    transform: "translate(-325.679 -573.725)",
    fill: "#f29866"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    "data-name": "Path 6649",
    d: "M318.123,564.338a28.48,28.48,0,0,0-4.088-.176c-.949.148-4.5,1.127-5.688.128s-.318-2.664-.318-2.664.307,2.886,2.4,2.516S316.407,562.988,318.123,564.338Z",
    transform: "translate(-238.778 -559.011)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    "data-name": "Path 6650",
    d: "M322.9,587.21a12.39,12.39,0,0,1-6.417,1.9,11.251,11.251,0,0,1,.826,2.262S322.068,590.029,322.9,587.21Z",
    transform: "translate(-241.863 -568.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    "data-name": "Path 6651",
    d: "M314.149,589.042s.282.477,1.371.693l-1.753,1.583s-.025-1.909,0-2.182S314.149,589.042,314.149,589.042Z",
    transform: "translate(-240.904 -568.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 3.872,
    cy: 3.999,
    rx: 3.872,
    ry: 3.999,
    transform: "matrix(-0.681, 0.732, -0.732, -0.681, 66.988, 36.287)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    "data-name": "Path 6652",
    d: "M292,615.07a3.874,3.874,0,1,0,5.274-5.671C298.734,614.028,294.961,615.151,292,615.07Z",
    transform: "translate(-233.238 -575.841)",
    fill: "#e3c883"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6653",
    "data-name": "Path 6653",
    d: "M289.656,610.9c.231.522.617,3.129-1.463,3.906-5.147,1.923-16.359,2.25-16.359,2.25l-.969-3.125s13.654-5.026,15.483-5.141A3.1,3.1,0,0,1,289.656,610.9Z",
    transform: "translate(-225.793 -575.623)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6654",
    "data-name": "Path 6654",
    d: "M290.357,614.456a16.343,16.343,0,0,1-5.222,2.092c-3.238.729-12.772,2.509-12.772,2.509s13.345-.312,16.96-2.571A2.257,2.257,0,0,0,290.357,614.456Z",
    transform: "translate(-226.321 -577.622)",
    fill: "#f29866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    d: "M315.282,597.191l-7.624,9.856-2.364.808S311.613,600.2,315.282,597.191Z",
    transform: "translate(-237.922 -571.54)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M324.13,591.854c3.512,5.526-6.329,15.274-13.056,19.364-2.114,1.285-4.015-.793-4.539-3.66-.37-2.025,1.3-2.278,1.541-2.744.6-1.165,6.653-8.854,6.653-8.854S321.768,588.138,324.13,591.854Z",
    transform: "translate(-238.341 -569.307)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M324.159,592.4c3.512,5.526-6.329,15.274-13.056,19.364-2.114,1.285-4.015-.793-4.539-3.66C314.015,615.053,321.839,597.158,324.159,592.4Z",
    transform: "translate(-238.37 -569.852)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(0 10.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(33.961 20.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 5.271,
    height: 5.271,
    transform: "translate(1.347 1.009) rotate(14.809)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6658",
    "data-name": "Path 6658",
    d: "M287.138,622.443l-27.708-7.858,1.615-6.108,27.974,6.852a3.68,3.68,0,0,1,2.7,4.518h0A3.679,3.679,0,0,1,287.138,622.443Z",
    transform: "translate(-255.726 -606.962)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 5.271,
    height: 5.271,
    transform: "translate(1.607 0) rotate(14.809)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6659",
    "data-name": "Path 6659",
    d: "M287.551,620.883l-27.708-7.857,1.615-6.108,27.974,6.852a3.68,3.68,0,0,1,2.7,4.518h0A3.68,3.68,0,0,1,287.551,620.883Z",
    transform: "translate(-255.872 -606.413)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6660",
    "data-name": "Path 6660",
    d: "M231.048,609.6a17.957,17.957,0,1,1-22.031-28.291A17.954,17.954,0,0,0,231.048,609.6Z",
    transform: "translate(-201.279 -576.907)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6661",
    "data-name": "Path 6661",
    d: "M223.856,574.649a17.955,17.955,0,1,0,15.6,20.036A17.9,17.9,0,0,0,223.856,574.649Zm13.263,19.745A15.6,15.6,0,1,1,223.564,577,15.545,15.545,0,0,1,237.118,594.394Z",
    transform: "translate(-202.125 -574.511)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6663",
    "data-name": "Path 6663",
    d: "M245.127,594.169a.588.588,0,0,1-.982-.5,9.493,9.493,0,0,0-8.24-10.58.588.588,0,0,1,.144-1.167,10.671,10.671,0,0,1,9.26,11.891A.574.574,0,0,1,245.127,594.169Z",
    transform: "translate(-213.296 -577.118)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 4.804,
    cy: 4.331,
    rx: 4.804,
    ry: 4.331,
    transform: "translate(76.805 41.156) rotate(161.875)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6664",
    "data-name": "Path 6664",
    d: "M303.668,617.8a4.83,4.83,0,0,0,9.131-2.989C311.4,620.078,306.728,619.331,303.668,617.8Z",
    transform: "translate(-237.35 -577.746)",
    fill: "#e3c883"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6665",
    "data-name": "Path 6665",
    d: "M305.968,615.006c.231.523.617,3.13-1.463,3.906-5.147,1.924-16.359,2.25-16.359,2.25l-.969-3.126s13.654-5.026,15.483-5.142A3.1,3.1,0,0,1,305.968,615.006Z",
    transform: "translate(-231.54 -577.069)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6666",
    "data-name": "Path 6666",
    d: "M307.177,618.56a16.352,16.352,0,0,1-5.223,2.093c-3.238.73-11.838,2.472-11.838,2.472s12.41-.276,16.026-2.534A2.259,2.259,0,0,0,307.177,618.56Z",
    transform: "translate(-232.576 -579.068)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(50.518 39.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6667",
    "data-name": "Path 6667",
    d: "M285.458,620.33a3.073,3.073,0,0,0-1.687-.777c-.443-.219-.878-.452-1.3-.708-.39-.235-.895-.753-1.372-.446-.593.383-.376,1.024.041,1.493a3.8,3.8,0,0,0-1.646,1.566.668.668,0,0,0-.036.944.963.963,0,0,0,.831.262.6.6,0,0,0,.21.415.991.991,0,0,0,1.1.06.98.98,0,0,0,1.132.428.819.819,0,0,0,.437.521,1.535,1.535,0,0,0,1.617-.411C285.892,622.839,286.641,621.484,285.458,620.33Z",
    transform: "translate(-279.274 -618.304)",
    fill: "#f5b379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6668",
    "data-name": "Path 6668",
    d: "M283.425,624.475h0Z",
    transform: "translate(-280.736 -620.477)",
    fill: "#f29866"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb1);
export default __webpack_public_path__ + "static/media/web1.6c61dcc3aaf3e3536527fd798b93d25a.svg";
export { ForwardRef as ReactComponent };